/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Texas = (function() {

    /**
     * Namespace Texas.
     * @exports Texas
     * @namespace
     */
    var Texas = {};

    Texas.PlayerAction = (function() {

        /**
         * Properties of a PlayerAction.
         * @memberof Texas
         * @interface IPlayerAction
         * @property {number} decision PlayerAction decision
         * @property {number|null} [mount] PlayerAction mount
         */

        /**
         * Constructs a new PlayerAction.
         * @memberof Texas
         * @classdesc Represents a PlayerAction.
         * @implements IPlayerAction
         * @constructor
         * @param {Texas.IPlayerAction=} [properties] Properties to set
         */
        function PlayerAction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PlayerAction decision.
         * @member {number} decision
         * @memberof Texas.PlayerAction
         * @instance
         */
        PlayerAction.prototype.decision = 0;

        /**
         * PlayerAction mount.
         * @member {number} mount
         * @memberof Texas.PlayerAction
         * @instance
         */
        PlayerAction.prototype.mount = 0;

        /**
         * Creates a new PlayerAction instance using the specified properties.
         * @function create
         * @memberof Texas.PlayerAction
         * @static
         * @param {Texas.IPlayerAction=} [properties] Properties to set
         * @returns {Texas.PlayerAction} PlayerAction instance
         */
        PlayerAction.create = function create(properties) {
            return new PlayerAction(properties);
        };

        /**
         * Encodes the specified PlayerAction message. Does not implicitly {@link Texas.PlayerAction.verify|verify} messages.
         * @function encode
         * @memberof Texas.PlayerAction
         * @static
         * @param {Texas.IPlayerAction} message PlayerAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.decision);
            if (message.mount != null && message.hasOwnProperty("mount"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.mount);
            return writer;
        };

        /**
         * Encodes the specified PlayerAction message, length delimited. Does not implicitly {@link Texas.PlayerAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.PlayerAction
         * @static
         * @param {Texas.IPlayerAction} message PlayerAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PlayerAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PlayerAction message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.PlayerAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.PlayerAction} PlayerAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.PlayerAction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.decision = reader.int32();
                    break;
                case 2:
                    message.mount = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("decision"))
                throw $util.ProtocolError("missing required 'decision'", { instance: message });
            return message;
        };

        /**
         * Decodes a PlayerAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.PlayerAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.PlayerAction} PlayerAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PlayerAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PlayerAction message.
         * @function verify
         * @memberof Texas.PlayerAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PlayerAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.decision))
                return "decision: integer expected";
            if (message.mount != null && message.hasOwnProperty("mount"))
                if (typeof message.mount !== "number")
                    return "mount: number expected";
            return null;
        };

        /**
         * Creates a PlayerAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.PlayerAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.PlayerAction} PlayerAction
         */
        PlayerAction.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.PlayerAction)
                return object;
            var message = new $root.Texas.PlayerAction();
            if (object.decision != null)
                message.decision = object.decision | 0;
            if (object.mount != null)
                message.mount = Number(object.mount);
            return message;
        };

        /**
         * Creates a plain object from a PlayerAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.PlayerAction
         * @static
         * @param {Texas.PlayerAction} message PlayerAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PlayerAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.decision = 0;
                object.mount = 0;
            }
            if (message.decision != null && message.hasOwnProperty("decision"))
                object.decision = message.decision;
            if (message.mount != null && message.hasOwnProperty("mount"))
                object.mount = options.json && !isFinite(message.mount) ? String(message.mount) : message.mount;
            return object;
        };

        /**
         * Converts this PlayerAction to JSON.
         * @function toJSON
         * @memberof Texas.PlayerAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PlayerAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PlayerAction;
    })();

    Texas.ActionReply = (function() {

        /**
         * Properties of an ActionReply.
         * @memberof Texas
         * @interface IActionReply
         * @property {boolean} ok ActionReply ok
         * @property {string|null} [desc] ActionReply desc
         * @property {number|null} [errorCode] ActionReply errorCode
         * @property {Texas.IPlayerAction|null} [action] ActionReply action
         */

        /**
         * Constructs a new ActionReply.
         * @memberof Texas
         * @classdesc Represents an ActionReply.
         * @implements IActionReply
         * @constructor
         * @param {Texas.IActionReply=} [properties] Properties to set
         */
        function ActionReply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ActionReply ok.
         * @member {boolean} ok
         * @memberof Texas.ActionReply
         * @instance
         */
        ActionReply.prototype.ok = false;

        /**
         * ActionReply desc.
         * @member {string} desc
         * @memberof Texas.ActionReply
         * @instance
         */
        ActionReply.prototype.desc = "";

        /**
         * ActionReply errorCode.
         * @member {number} errorCode
         * @memberof Texas.ActionReply
         * @instance
         */
        ActionReply.prototype.errorCode = 0;

        /**
         * ActionReply action.
         * @member {Texas.IPlayerAction|null|undefined} action
         * @memberof Texas.ActionReply
         * @instance
         */
        ActionReply.prototype.action = null;

        /**
         * Creates a new ActionReply instance using the specified properties.
         * @function create
         * @memberof Texas.ActionReply
         * @static
         * @param {Texas.IActionReply=} [properties] Properties to set
         * @returns {Texas.ActionReply} ActionReply instance
         */
        ActionReply.create = function create(properties) {
            return new ActionReply(properties);
        };

        /**
         * Encodes the specified ActionReply message. Does not implicitly {@link Texas.ActionReply.verify|verify} messages.
         * @function encode
         * @memberof Texas.ActionReply
         * @static
         * @param {Texas.IActionReply} message ActionReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionReply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.ok);
            if (message.desc != null && message.hasOwnProperty("desc"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.desc);
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.errorCode);
            if (message.action != null && message.hasOwnProperty("action"))
                $root.Texas.PlayerAction.encode(message.action, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ActionReply message, length delimited. Does not implicitly {@link Texas.ActionReply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.ActionReply
         * @static
         * @param {Texas.IActionReply} message ActionReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionReply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ActionReply message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.ActionReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.ActionReply} ActionReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionReply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.ActionReply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ok = reader.bool();
                    break;
                case 2:
                    message.desc = reader.string();
                    break;
                case 3:
                    message.errorCode = reader.int32();
                    break;
                case 4:
                    message.action = $root.Texas.PlayerAction.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("ok"))
                throw $util.ProtocolError("missing required 'ok'", { instance: message });
            return message;
        };

        /**
         * Decodes an ActionReply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.ActionReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.ActionReply} ActionReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionReply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActionReply message.
         * @function verify
         * @memberof Texas.ActionReply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActionReply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.ok !== "boolean")
                return "ok: boolean expected";
            if (message.desc != null && message.hasOwnProperty("desc"))
                if (!$util.isString(message.desc))
                    return "desc: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isInteger(message.errorCode))
                    return "errorCode: integer expected";
            if (message.action != null && message.hasOwnProperty("action")) {
                var error = $root.Texas.PlayerAction.verify(message.action);
                if (error)
                    return "action." + error;
            }
            return null;
        };

        /**
         * Creates an ActionReply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.ActionReply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.ActionReply} ActionReply
         */
        ActionReply.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.ActionReply)
                return object;
            var message = new $root.Texas.ActionReply();
            if (object.ok != null)
                message.ok = Boolean(object.ok);
            if (object.desc != null)
                message.desc = String(object.desc);
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            if (object.action != null) {
                if (typeof object.action !== "object")
                    throw TypeError(".Texas.ActionReply.action: object expected");
                message.action = $root.Texas.PlayerAction.fromObject(object.action);
            }
            return message;
        };

        /**
         * Creates a plain object from an ActionReply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.ActionReply
         * @static
         * @param {Texas.ActionReply} message ActionReply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActionReply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ok = false;
                object.desc = "";
                object.errorCode = 0;
                object.action = null;
            }
            if (message.ok != null && message.hasOwnProperty("ok"))
                object.ok = message.ok;
            if (message.desc != null && message.hasOwnProperty("desc"))
                object.desc = message.desc;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = $root.Texas.PlayerAction.toObject(message.action, options);
            return object;
        };

        /**
         * Converts this ActionReply to JSON.
         * @function toJSON
         * @memberof Texas.ActionReply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActionReply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ActionReply;
    })();

    Texas.ActionBroadcast = (function() {

        /**
         * Properties of an ActionBroadcast.
         * @memberof Texas
         * @interface IActionBroadcast
         * @property {number} playerPos ActionBroadcast playerPos
         * @property {Texas.IPlayerAction} currentAction ActionBroadcast currentAction
         * @property {Texas.INextAction|null} [nextAction] ActionBroadcast nextAction
         * @property {number|null} [pot] ActionBroadcast pot
         * @property {number|null} [bet] ActionBroadcast bet
         * @property {number|null} [chips] ActionBroadcast chips
         */

        /**
         * Constructs a new ActionBroadcast.
         * @memberof Texas
         * @classdesc Represents an ActionBroadcast.
         * @implements IActionBroadcast
         * @constructor
         * @param {Texas.IActionBroadcast=} [properties] Properties to set
         */
        function ActionBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ActionBroadcast playerPos.
         * @member {number} playerPos
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.playerPos = 0;

        /**
         * ActionBroadcast currentAction.
         * @member {Texas.IPlayerAction} currentAction
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.currentAction = null;

        /**
         * ActionBroadcast nextAction.
         * @member {Texas.INextAction|null|undefined} nextAction
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.nextAction = null;

        /**
         * ActionBroadcast pot.
         * @member {number} pot
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.pot = 0;

        /**
         * ActionBroadcast bet.
         * @member {number} bet
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.bet = 0;

        /**
         * ActionBroadcast chips.
         * @member {number} chips
         * @memberof Texas.ActionBroadcast
         * @instance
         */
        ActionBroadcast.prototype.chips = 0;

        /**
         * Creates a new ActionBroadcast instance using the specified properties.
         * @function create
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Texas.IActionBroadcast=} [properties] Properties to set
         * @returns {Texas.ActionBroadcast} ActionBroadcast instance
         */
        ActionBroadcast.create = function create(properties) {
            return new ActionBroadcast(properties);
        };

        /**
         * Encodes the specified ActionBroadcast message. Does not implicitly {@link Texas.ActionBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Texas.IActionBroadcast} message ActionBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerPos);
            $root.Texas.PlayerAction.encode(message.currentAction, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.nextAction != null && message.hasOwnProperty("nextAction"))
                $root.Texas.NextAction.encode(message.nextAction, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.pot != null && message.hasOwnProperty("pot"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.pot);
            if (message.bet != null && message.hasOwnProperty("bet"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.bet);
            if (message.chips != null && message.hasOwnProperty("chips"))
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.chips);
            return writer;
        };

        /**
         * Encodes the specified ActionBroadcast message, length delimited. Does not implicitly {@link Texas.ActionBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Texas.IActionBroadcast} message ActionBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ActionBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ActionBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.ActionBroadcast} ActionBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.ActionBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerPos = reader.int32();
                    break;
                case 2:
                    message.currentAction = $root.Texas.PlayerAction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextAction = $root.Texas.NextAction.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pot = reader.double();
                    break;
                case 5:
                    message.bet = reader.double();
                    break;
                case 6:
                    message.chips = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerPos"))
                throw $util.ProtocolError("missing required 'playerPos'", { instance: message });
            if (!message.hasOwnProperty("currentAction"))
                throw $util.ProtocolError("missing required 'currentAction'", { instance: message });
            return message;
        };

        /**
         * Decodes an ActionBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.ActionBroadcast} ActionBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ActionBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ActionBroadcast message.
         * @function verify
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ActionBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerPos))
                return "playerPos: integer expected";
            {
                var error = $root.Texas.PlayerAction.verify(message.currentAction);
                if (error)
                    return "currentAction." + error;
            }
            if (message.nextAction != null && message.hasOwnProperty("nextAction")) {
                var error = $root.Texas.NextAction.verify(message.nextAction);
                if (error)
                    return "nextAction." + error;
            }
            if (message.pot != null && message.hasOwnProperty("pot"))
                if (typeof message.pot !== "number")
                    return "pot: number expected";
            if (message.bet != null && message.hasOwnProperty("bet"))
                if (typeof message.bet !== "number")
                    return "bet: number expected";
            if (message.chips != null && message.hasOwnProperty("chips"))
                if (typeof message.chips !== "number")
                    return "chips: number expected";
            return null;
        };

        /**
         * Creates an ActionBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.ActionBroadcast} ActionBroadcast
         */
        ActionBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.ActionBroadcast)
                return object;
            var message = new $root.Texas.ActionBroadcast();
            if (object.playerPos != null)
                message.playerPos = object.playerPos | 0;
            if (object.currentAction != null) {
                if (typeof object.currentAction !== "object")
                    throw TypeError(".Texas.ActionBroadcast.currentAction: object expected");
                message.currentAction = $root.Texas.PlayerAction.fromObject(object.currentAction);
            }
            if (object.nextAction != null) {
                if (typeof object.nextAction !== "object")
                    throw TypeError(".Texas.ActionBroadcast.nextAction: object expected");
                message.nextAction = $root.Texas.NextAction.fromObject(object.nextAction);
            }
            if (object.pot != null)
                message.pot = Number(object.pot);
            if (object.bet != null)
                message.bet = Number(object.bet);
            if (object.chips != null)
                message.chips = Number(object.chips);
            return message;
        };

        /**
         * Creates a plain object from an ActionBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.ActionBroadcast
         * @static
         * @param {Texas.ActionBroadcast} message ActionBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ActionBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerPos = 0;
                object.currentAction = null;
                object.nextAction = null;
                object.pot = 0;
                object.bet = 0;
                object.chips = 0;
            }
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                object.playerPos = message.playerPos;
            if (message.currentAction != null && message.hasOwnProperty("currentAction"))
                object.currentAction = $root.Texas.PlayerAction.toObject(message.currentAction, options);
            if (message.nextAction != null && message.hasOwnProperty("nextAction"))
                object.nextAction = $root.Texas.NextAction.toObject(message.nextAction, options);
            if (message.pot != null && message.hasOwnProperty("pot"))
                object.pot = options.json && !isFinite(message.pot) ? String(message.pot) : message.pot;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
            if (message.chips != null && message.hasOwnProperty("chips"))
                object.chips = options.json && !isFinite(message.chips) ? String(message.chips) : message.chips;
            return object;
        };

        /**
         * Converts this ActionBroadcast to JSON.
         * @function toJSON
         * @memberof Texas.ActionBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ActionBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ActionBroadcast;
    })();

    Texas.LastAction = (function() {

        /**
         * Properties of a LastAction.
         * @memberof Texas
         * @interface ILastAction
         * @property {number} playerId LastAction playerId
         * @property {Texas.IPlayerAction} action LastAction action
         */

        /**
         * Constructs a new LastAction.
         * @memberof Texas
         * @classdesc Represents a LastAction.
         * @implements ILastAction
         * @constructor
         * @param {Texas.ILastAction=} [properties] Properties to set
         */
        function LastAction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LastAction playerId.
         * @member {number} playerId
         * @memberof Texas.LastAction
         * @instance
         */
        LastAction.prototype.playerId = 0;

        /**
         * LastAction action.
         * @member {Texas.IPlayerAction} action
         * @memberof Texas.LastAction
         * @instance
         */
        LastAction.prototype.action = null;

        /**
         * Creates a new LastAction instance using the specified properties.
         * @function create
         * @memberof Texas.LastAction
         * @static
         * @param {Texas.ILastAction=} [properties] Properties to set
         * @returns {Texas.LastAction} LastAction instance
         */
        LastAction.create = function create(properties) {
            return new LastAction(properties);
        };

        /**
         * Encodes the specified LastAction message. Does not implicitly {@link Texas.LastAction.verify|verify} messages.
         * @function encode
         * @memberof Texas.LastAction
         * @static
         * @param {Texas.ILastAction} message LastAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            $root.Texas.PlayerAction.encode(message.action, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified LastAction message, length delimited. Does not implicitly {@link Texas.LastAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.LastAction
         * @static
         * @param {Texas.ILastAction} message LastAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LastAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LastAction message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.LastAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.LastAction} LastAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.LastAction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.action = $root.Texas.PlayerAction.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("action"))
                throw $util.ProtocolError("missing required 'action'", { instance: message });
            return message;
        };

        /**
         * Decodes a LastAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.LastAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.LastAction} LastAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LastAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LastAction message.
         * @function verify
         * @memberof Texas.LastAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LastAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            {
                var error = $root.Texas.PlayerAction.verify(message.action);
                if (error)
                    return "action." + error;
            }
            return null;
        };

        /**
         * Creates a LastAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.LastAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.LastAction} LastAction
         */
        LastAction.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.LastAction)
                return object;
            var message = new $root.Texas.LastAction();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.action != null) {
                if (typeof object.action !== "object")
                    throw TypeError(".Texas.LastAction.action: object expected");
                message.action = $root.Texas.PlayerAction.fromObject(object.action);
            }
            return message;
        };

        /**
         * Creates a plain object from a LastAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.LastAction
         * @static
         * @param {Texas.LastAction} message LastAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LastAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.action = null;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = $root.Texas.PlayerAction.toObject(message.action, options);
            return object;
        };

        /**
         * Converts this LastAction to JSON.
         * @function toJSON
         * @memberof Texas.LastAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LastAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LastAction;
    })();

    Texas.NextPlayerAction = (function() {

        /**
         * Properties of a NextPlayerAction.
         * @memberof Texas
         * @interface INextPlayerAction
         * @property {number} playerId NextPlayerAction playerId
         * @property {Array.<number>|null} [decisionAllowed] NextPlayerAction decisionAllowed
         * @property {number|null} [min] NextPlayerAction min
         * @property {number|null} [max] NextPlayerAction max
         * @property {boolean|null} [multiple] NextPlayerAction multiple
         * @property {number|null} [opTime] NextPlayerAction opTime
         * @property {number|null} [callBet] NextPlayerAction callBet
         */

        /**
         * Constructs a new NextPlayerAction.
         * @memberof Texas
         * @classdesc Represents a NextPlayerAction.
         * @implements INextPlayerAction
         * @constructor
         * @param {Texas.INextPlayerAction=} [properties] Properties to set
         */
        function NextPlayerAction(properties) {
            this.decisionAllowed = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NextPlayerAction playerId.
         * @member {number} playerId
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.playerId = 0;

        /**
         * NextPlayerAction decisionAllowed.
         * @member {Array.<number>} decisionAllowed
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.decisionAllowed = $util.emptyArray;

        /**
         * NextPlayerAction min.
         * @member {number} min
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.min = 0;

        /**
         * NextPlayerAction max.
         * @member {number} max
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.max = 0;

        /**
         * NextPlayerAction multiple.
         * @member {boolean} multiple
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.multiple = false;

        /**
         * NextPlayerAction opTime.
         * @member {number} opTime
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.opTime = 0;

        /**
         * NextPlayerAction callBet.
         * @member {number} callBet
         * @memberof Texas.NextPlayerAction
         * @instance
         */
        NextPlayerAction.prototype.callBet = 0;

        /**
         * Creates a new NextPlayerAction instance using the specified properties.
         * @function create
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Texas.INextPlayerAction=} [properties] Properties to set
         * @returns {Texas.NextPlayerAction} NextPlayerAction instance
         */
        NextPlayerAction.create = function create(properties) {
            return new NextPlayerAction(properties);
        };

        /**
         * Encodes the specified NextPlayerAction message. Does not implicitly {@link Texas.NextPlayerAction.verify|verify} messages.
         * @function encode
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Texas.INextPlayerAction} message NextPlayerAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NextPlayerAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.decisionAllowed != null && message.decisionAllowed.length)
                for (var i = 0; i < message.decisionAllowed.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.decisionAllowed[i]);
            if (message.min != null && message.hasOwnProperty("min"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.min);
            if (message.max != null && message.hasOwnProperty("max"))
                writer.uint32(/* id 4, wireType 1 =*/33).double(message.max);
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.multiple);
            if (message.opTime != null && message.hasOwnProperty("opTime"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.opTime);
            if (message.callBet != null && message.hasOwnProperty("callBet"))
                writer.uint32(/* id 7, wireType 1 =*/57).double(message.callBet);
            return writer;
        };

        /**
         * Encodes the specified NextPlayerAction message, length delimited. Does not implicitly {@link Texas.NextPlayerAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Texas.INextPlayerAction} message NextPlayerAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NextPlayerAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NextPlayerAction message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.NextPlayerAction} NextPlayerAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NextPlayerAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.NextPlayerAction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    if (!(message.decisionAllowed && message.decisionAllowed.length))
                        message.decisionAllowed = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.decisionAllowed.push(reader.int32());
                    } else
                        message.decisionAllowed.push(reader.int32());
                    break;
                case 3:
                    message.min = reader.double();
                    break;
                case 4:
                    message.max = reader.double();
                    break;
                case 5:
                    message.multiple = reader.bool();
                    break;
                case 6:
                    message.opTime = reader.int32();
                    break;
                case 7:
                    message.callBet = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a NextPlayerAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.NextPlayerAction} NextPlayerAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NextPlayerAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NextPlayerAction message.
         * @function verify
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NextPlayerAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.decisionAllowed != null && message.hasOwnProperty("decisionAllowed")) {
                if (!Array.isArray(message.decisionAllowed))
                    return "decisionAllowed: array expected";
                for (var i = 0; i < message.decisionAllowed.length; ++i)
                    if (!$util.isInteger(message.decisionAllowed[i]))
                        return "decisionAllowed: integer[] expected";
            }
            if (message.min != null && message.hasOwnProperty("min"))
                if (typeof message.min !== "number")
                    return "min: number expected";
            if (message.max != null && message.hasOwnProperty("max"))
                if (typeof message.max !== "number")
                    return "max: number expected";
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                if (typeof message.multiple !== "boolean")
                    return "multiple: boolean expected";
            if (message.opTime != null && message.hasOwnProperty("opTime"))
                if (!$util.isInteger(message.opTime))
                    return "opTime: integer expected";
            if (message.callBet != null && message.hasOwnProperty("callBet"))
                if (typeof message.callBet !== "number")
                    return "callBet: number expected";
            return null;
        };

        /**
         * Creates a NextPlayerAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.NextPlayerAction} NextPlayerAction
         */
        NextPlayerAction.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.NextPlayerAction)
                return object;
            var message = new $root.Texas.NextPlayerAction();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.decisionAllowed) {
                if (!Array.isArray(object.decisionAllowed))
                    throw TypeError(".Texas.NextPlayerAction.decisionAllowed: array expected");
                message.decisionAllowed = [];
                for (var i = 0; i < object.decisionAllowed.length; ++i)
                    message.decisionAllowed[i] = object.decisionAllowed[i] | 0;
            }
            if (object.min != null)
                message.min = Number(object.min);
            if (object.max != null)
                message.max = Number(object.max);
            if (object.multiple != null)
                message.multiple = Boolean(object.multiple);
            if (object.opTime != null)
                message.opTime = object.opTime | 0;
            if (object.callBet != null)
                message.callBet = Number(object.callBet);
            return message;
        };

        /**
         * Creates a plain object from a NextPlayerAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.NextPlayerAction
         * @static
         * @param {Texas.NextPlayerAction} message NextPlayerAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NextPlayerAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.decisionAllowed = [];
            if (options.defaults) {
                object.playerId = 0;
                object.min = 0;
                object.max = 0;
                object.multiple = false;
                object.opTime = 0;
                object.callBet = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.decisionAllowed && message.decisionAllowed.length) {
                object.decisionAllowed = [];
                for (var j = 0; j < message.decisionAllowed.length; ++j)
                    object.decisionAllowed[j] = message.decisionAllowed[j];
            }
            if (message.min != null && message.hasOwnProperty("min"))
                object.min = options.json && !isFinite(message.min) ? String(message.min) : message.min;
            if (message.max != null && message.hasOwnProperty("max"))
                object.max = options.json && !isFinite(message.max) ? String(message.max) : message.max;
            if (message.multiple != null && message.hasOwnProperty("multiple"))
                object.multiple = message.multiple;
            if (message.opTime != null && message.hasOwnProperty("opTime"))
                object.opTime = message.opTime;
            if (message.callBet != null && message.hasOwnProperty("callBet"))
                object.callBet = options.json && !isFinite(message.callBet) ? String(message.callBet) : message.callBet;
            return object;
        };

        /**
         * Converts this NextPlayerAction to JSON.
         * @function toJSON
         * @memberof Texas.NextPlayerAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NextPlayerAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NextPlayerAction;
    })();

    Texas.NextAction = (function() {

        /**
         * Properties of a NextAction.
         * @memberof Texas
         * @interface INextAction
         * @property {number} state NextAction state
         * @property {Texas.INextPlayerAction|null} [playerAction] NextAction playerAction
         * @property {Array.<number>|null} [publicCards] NextAction publicCards
         * @property {Texas.IGameSettlement|null} [gameSettlement] NextAction gameSettlement
         * @property {Texas.IMaxCardInfo|null} [maxCardInfo] NextAction maxCardInfo
         * @property {Array.<Texas.ISidePot>|null} [sidePots] NextAction sidePots
         * @property {Texas.NextAction.IGameEndInfo|null} [gameEndInfo] NextAction gameEndInfo
         * @property {Array.<Texas.NextAction.IPlayer>|null} [players] NextAction players
         * @property {number|null} [sidePotNum] NextAction sidePotNum
         */

        /**
         * Constructs a new NextAction.
         * @memberof Texas
         * @classdesc Represents a NextAction.
         * @implements INextAction
         * @constructor
         * @param {Texas.INextAction=} [properties] Properties to set
         */
        function NextAction(properties) {
            this.publicCards = [];
            this.sidePots = [];
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * NextAction state.
         * @member {number} state
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.state = 0;

        /**
         * NextAction playerAction.
         * @member {Texas.INextPlayerAction|null|undefined} playerAction
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.playerAction = null;

        /**
         * NextAction publicCards.
         * @member {Array.<number>} publicCards
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.publicCards = $util.emptyArray;

        /**
         * NextAction gameSettlement.
         * @member {Texas.IGameSettlement|null|undefined} gameSettlement
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.gameSettlement = null;

        /**
         * NextAction maxCardInfo.
         * @member {Texas.IMaxCardInfo|null|undefined} maxCardInfo
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.maxCardInfo = null;

        /**
         * NextAction sidePots.
         * @member {Array.<Texas.ISidePot>} sidePots
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.sidePots = $util.emptyArray;

        /**
         * NextAction gameEndInfo.
         * @member {Texas.NextAction.IGameEndInfo|null|undefined} gameEndInfo
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.gameEndInfo = null;

        /**
         * NextAction players.
         * @member {Array.<Texas.NextAction.IPlayer>} players
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.players = $util.emptyArray;

        /**
         * NextAction sidePotNum.
         * @member {number} sidePotNum
         * @memberof Texas.NextAction
         * @instance
         */
        NextAction.prototype.sidePotNum = 0;

        /**
         * Creates a new NextAction instance using the specified properties.
         * @function create
         * @memberof Texas.NextAction
         * @static
         * @param {Texas.INextAction=} [properties] Properties to set
         * @returns {Texas.NextAction} NextAction instance
         */
        NextAction.create = function create(properties) {
            return new NextAction(properties);
        };

        /**
         * Encodes the specified NextAction message. Does not implicitly {@link Texas.NextAction.verify|verify} messages.
         * @function encode
         * @memberof Texas.NextAction
         * @static
         * @param {Texas.INextAction} message NextAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NextAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
            if (message.playerAction != null && message.hasOwnProperty("playerAction"))
                $root.Texas.NextPlayerAction.encode(message.playerAction, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.publicCards != null && message.publicCards.length)
                for (var i = 0; i < message.publicCards.length; ++i)
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.publicCards[i]);
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement"))
                $root.Texas.GameSettlement.encode(message.gameSettlement, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                $root.Texas.MaxCardInfo.encode(message.maxCardInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.sidePots != null && message.sidePots.length)
                for (var i = 0; i < message.sidePots.length; ++i)
                    $root.Texas.SidePot.encode(message.sidePots[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.gameEndInfo != null && message.hasOwnProperty("gameEndInfo"))
                $root.Texas.NextAction.GameEndInfo.encode(message.gameEndInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Texas.NextAction.Player.encode(message.players[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.sidePotNum != null && message.hasOwnProperty("sidePotNum"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.sidePotNum);
            return writer;
        };

        /**
         * Encodes the specified NextAction message, length delimited. Does not implicitly {@link Texas.NextAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.NextAction
         * @static
         * @param {Texas.INextAction} message NextAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NextAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NextAction message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.NextAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.NextAction} NextAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NextAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.NextAction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.playerAction = $root.Texas.NextPlayerAction.decode(reader, reader.uint32());
                    break;
                case 3:
                    if (!(message.publicCards && message.publicCards.length))
                        message.publicCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.publicCards.push(reader.int32());
                    } else
                        message.publicCards.push(reader.int32());
                    break;
                case 4:
                    message.gameSettlement = $root.Texas.GameSettlement.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxCardInfo = $root.Texas.MaxCardInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    if (!(message.sidePots && message.sidePots.length))
                        message.sidePots = [];
                    message.sidePots.push($root.Texas.SidePot.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.gameEndInfo = $root.Texas.NextAction.GameEndInfo.decode(reader, reader.uint32());
                    break;
                case 8:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Texas.NextAction.Player.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.sidePotNum = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("state"))
                throw $util.ProtocolError("missing required 'state'", { instance: message });
            return message;
        };

        /**
         * Decodes a NextAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.NextAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.NextAction} NextAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NextAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NextAction message.
         * @function verify
         * @memberof Texas.NextAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NextAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.state))
                return "state: integer expected";
            if (message.playerAction != null && message.hasOwnProperty("playerAction")) {
                var error = $root.Texas.NextPlayerAction.verify(message.playerAction);
                if (error)
                    return "playerAction." + error;
            }
            if (message.publicCards != null && message.hasOwnProperty("publicCards")) {
                if (!Array.isArray(message.publicCards))
                    return "publicCards: array expected";
                for (var i = 0; i < message.publicCards.length; ++i)
                    if (!$util.isInteger(message.publicCards[i]))
                        return "publicCards: integer[] expected";
            }
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement")) {
                var error = $root.Texas.GameSettlement.verify(message.gameSettlement);
                if (error)
                    return "gameSettlement." + error;
            }
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo")) {
                var error = $root.Texas.MaxCardInfo.verify(message.maxCardInfo);
                if (error)
                    return "maxCardInfo." + error;
            }
            if (message.sidePots != null && message.hasOwnProperty("sidePots")) {
                if (!Array.isArray(message.sidePots))
                    return "sidePots: array expected";
                for (var i = 0; i < message.sidePots.length; ++i) {
                    var error = $root.Texas.SidePot.verify(message.sidePots[i]);
                    if (error)
                        return "sidePots." + error;
                }
            }
            if (message.gameEndInfo != null && message.hasOwnProperty("gameEndInfo")) {
                var error = $root.Texas.NextAction.GameEndInfo.verify(message.gameEndInfo);
                if (error)
                    return "gameEndInfo." + error;
            }
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Texas.NextAction.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (message.sidePotNum != null && message.hasOwnProperty("sidePotNum"))
                if (!$util.isInteger(message.sidePotNum))
                    return "sidePotNum: integer expected";
            return null;
        };

        /**
         * Creates a NextAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.NextAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.NextAction} NextAction
         */
        NextAction.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.NextAction)
                return object;
            var message = new $root.Texas.NextAction();
            if (object.state != null)
                message.state = object.state | 0;
            if (object.playerAction != null) {
                if (typeof object.playerAction !== "object")
                    throw TypeError(".Texas.NextAction.playerAction: object expected");
                message.playerAction = $root.Texas.NextPlayerAction.fromObject(object.playerAction);
            }
            if (object.publicCards) {
                if (!Array.isArray(object.publicCards))
                    throw TypeError(".Texas.NextAction.publicCards: array expected");
                message.publicCards = [];
                for (var i = 0; i < object.publicCards.length; ++i)
                    message.publicCards[i] = object.publicCards[i] | 0;
            }
            if (object.gameSettlement != null) {
                if (typeof object.gameSettlement !== "object")
                    throw TypeError(".Texas.NextAction.gameSettlement: object expected");
                message.gameSettlement = $root.Texas.GameSettlement.fromObject(object.gameSettlement);
            }
            if (object.maxCardInfo != null) {
                if (typeof object.maxCardInfo !== "object")
                    throw TypeError(".Texas.NextAction.maxCardInfo: object expected");
                message.maxCardInfo = $root.Texas.MaxCardInfo.fromObject(object.maxCardInfo);
            }
            if (object.sidePots) {
                if (!Array.isArray(object.sidePots))
                    throw TypeError(".Texas.NextAction.sidePots: array expected");
                message.sidePots = [];
                for (var i = 0; i < object.sidePots.length; ++i) {
                    if (typeof object.sidePots[i] !== "object")
                        throw TypeError(".Texas.NextAction.sidePots: object expected");
                    message.sidePots[i] = $root.Texas.SidePot.fromObject(object.sidePots[i]);
                }
            }
            if (object.gameEndInfo != null) {
                if (typeof object.gameEndInfo !== "object")
                    throw TypeError(".Texas.NextAction.gameEndInfo: object expected");
                message.gameEndInfo = $root.Texas.NextAction.GameEndInfo.fromObject(object.gameEndInfo);
            }
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Texas.NextAction.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Texas.NextAction.players: object expected");
                    message.players[i] = $root.Texas.NextAction.Player.fromObject(object.players[i]);
                }
            }
            if (object.sidePotNum != null)
                message.sidePotNum = object.sidePotNum | 0;
            return message;
        };

        /**
         * Creates a plain object from a NextAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.NextAction
         * @static
         * @param {Texas.NextAction} message NextAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NextAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.publicCards = [];
                object.sidePots = [];
                object.players = [];
            }
            if (options.defaults) {
                object.state = 0;
                object.playerAction = null;
                object.gameSettlement = null;
                object.maxCardInfo = null;
                object.gameEndInfo = null;
                object.sidePotNum = 0;
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.playerAction != null && message.hasOwnProperty("playerAction"))
                object.playerAction = $root.Texas.NextPlayerAction.toObject(message.playerAction, options);
            if (message.publicCards && message.publicCards.length) {
                object.publicCards = [];
                for (var j = 0; j < message.publicCards.length; ++j)
                    object.publicCards[j] = message.publicCards[j];
            }
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement"))
                object.gameSettlement = $root.Texas.GameSettlement.toObject(message.gameSettlement, options);
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                object.maxCardInfo = $root.Texas.MaxCardInfo.toObject(message.maxCardInfo, options);
            if (message.sidePots && message.sidePots.length) {
                object.sidePots = [];
                for (var j = 0; j < message.sidePots.length; ++j)
                    object.sidePots[j] = $root.Texas.SidePot.toObject(message.sidePots[j], options);
            }
            if (message.gameEndInfo != null && message.hasOwnProperty("gameEndInfo"))
                object.gameEndInfo = $root.Texas.NextAction.GameEndInfo.toObject(message.gameEndInfo, options);
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Texas.NextAction.Player.toObject(message.players[j], options);
            }
            if (message.sidePotNum != null && message.hasOwnProperty("sidePotNum"))
                object.sidePotNum = message.sidePotNum;
            return object;
        };

        /**
         * Converts this NextAction to JSON.
         * @function toJSON
         * @memberof Texas.NextAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NextAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        NextAction.GameEndInfo = (function() {

            /**
             * Properties of a GameEndInfo.
             * @memberof Texas.NextAction
             * @interface IGameEndInfo
             * @property {string|null} [startTime] GameEndInfo startTime
             * @property {string|null} [endTime] GameEndInfo endTime
             * @property {number|null} [nextRoundStartTime] GameEndInfo nextRoundStartTime
             */

            /**
             * Constructs a new GameEndInfo.
             * @memberof Texas.NextAction
             * @classdesc Represents a GameEndInfo.
             * @implements IGameEndInfo
             * @constructor
             * @param {Texas.NextAction.IGameEndInfo=} [properties] Properties to set
             */
            function GameEndInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GameEndInfo startTime.
             * @member {string} startTime
             * @memberof Texas.NextAction.GameEndInfo
             * @instance
             */
            GameEndInfo.prototype.startTime = "";

            /**
             * GameEndInfo endTime.
             * @member {string} endTime
             * @memberof Texas.NextAction.GameEndInfo
             * @instance
             */
            GameEndInfo.prototype.endTime = "";

            /**
             * GameEndInfo nextRoundStartTime.
             * @member {number} nextRoundStartTime
             * @memberof Texas.NextAction.GameEndInfo
             * @instance
             */
            GameEndInfo.prototype.nextRoundStartTime = 0;

            /**
             * Creates a new GameEndInfo instance using the specified properties.
             * @function create
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Texas.NextAction.IGameEndInfo=} [properties] Properties to set
             * @returns {Texas.NextAction.GameEndInfo} GameEndInfo instance
             */
            GameEndInfo.create = function create(properties) {
                return new GameEndInfo(properties);
            };

            /**
             * Encodes the specified GameEndInfo message. Does not implicitly {@link Texas.NextAction.GameEndInfo.verify|verify} messages.
             * @function encode
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Texas.NextAction.IGameEndInfo} message GameEndInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GameEndInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.startTime);
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.endTime);
                if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.nextRoundStartTime);
                return writer;
            };

            /**
             * Encodes the specified GameEndInfo message, length delimited. Does not implicitly {@link Texas.NextAction.GameEndInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Texas.NextAction.IGameEndInfo} message GameEndInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GameEndInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GameEndInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Texas.NextAction.GameEndInfo} GameEndInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GameEndInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.NextAction.GameEndInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.startTime = reader.string();
                        break;
                    case 2:
                        message.endTime = reader.string();
                        break;
                    case 3:
                        message.nextRoundStartTime = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GameEndInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Texas.NextAction.GameEndInfo} GameEndInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GameEndInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GameEndInfo message.
             * @function verify
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GameEndInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    if (!$util.isString(message.startTime))
                        return "startTime: string expected";
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    if (!$util.isString(message.endTime))
                        return "endTime: string expected";
                if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                    if (!$util.isInteger(message.nextRoundStartTime))
                        return "nextRoundStartTime: integer expected";
                return null;
            };

            /**
             * Creates a GameEndInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Texas.NextAction.GameEndInfo} GameEndInfo
             */
            GameEndInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Texas.NextAction.GameEndInfo)
                    return object;
                var message = new $root.Texas.NextAction.GameEndInfo();
                if (object.startTime != null)
                    message.startTime = String(object.startTime);
                if (object.endTime != null)
                    message.endTime = String(object.endTime);
                if (object.nextRoundStartTime != null)
                    message.nextRoundStartTime = object.nextRoundStartTime | 0;
                return message;
            };

            /**
             * Creates a plain object from a GameEndInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Texas.NextAction.GameEndInfo
             * @static
             * @param {Texas.NextAction.GameEndInfo} message GameEndInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GameEndInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.startTime = "";
                    object.endTime = "";
                    object.nextRoundStartTime = 0;
                }
                if (message.startTime != null && message.hasOwnProperty("startTime"))
                    object.startTime = message.startTime;
                if (message.endTime != null && message.hasOwnProperty("endTime"))
                    object.endTime = message.endTime;
                if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                    object.nextRoundStartTime = message.nextRoundStartTime;
                return object;
            };

            /**
             * Converts this GameEndInfo to JSON.
             * @function toJSON
             * @memberof Texas.NextAction.GameEndInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GameEndInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GameEndInfo;
        })();

        NextAction.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof Texas.NextAction
             * @interface IPlayer
             * @property {number|null} [pos] Player pos
             * @property {number|null} [winRate] Player winRate
             */

            /**
             * Constructs a new Player.
             * @memberof Texas.NextAction
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {Texas.NextAction.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player pos.
             * @member {number} pos
             * @memberof Texas.NextAction.Player
             * @instance
             */
            Player.prototype.pos = 0;

            /**
             * Player winRate.
             * @member {number} winRate
             * @memberof Texas.NextAction.Player
             * @instance
             */
            Player.prototype.winRate = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Texas.NextAction.IPlayer=} [properties] Properties to set
             * @returns {Texas.NextAction.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link Texas.NextAction.Player.verify|verify} messages.
             * @function encode
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Texas.NextAction.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.pos != null && message.hasOwnProperty("pos"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pos);
                if (message.winRate != null && message.hasOwnProperty("winRate"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.winRate);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link Texas.NextAction.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Texas.NextAction.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof Texas.NextAction.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Texas.NextAction.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.NextAction.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.int32();
                        break;
                    case 2:
                        message.winRate = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Texas.NextAction.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Texas.NextAction.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.pos != null && message.hasOwnProperty("pos"))
                    if (!$util.isInteger(message.pos))
                        return "pos: integer expected";
                if (message.winRate != null && message.hasOwnProperty("winRate"))
                    if (typeof message.winRate !== "number")
                        return "winRate: number expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Texas.NextAction.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.Texas.NextAction.Player)
                    return object;
                var message = new $root.Texas.NextAction.Player();
                if (object.pos != null)
                    message.pos = object.pos | 0;
                if (object.winRate != null)
                    message.winRate = Number(object.winRate);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Texas.NextAction.Player
             * @static
             * @param {Texas.NextAction.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.pos = 0;
                    object.winRate = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.winRate != null && message.hasOwnProperty("winRate"))
                    object.winRate = options.json && !isFinite(message.winRate) ? String(message.winRate) : message.winRate;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof Texas.NextAction.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return NextAction;
    })();

    Texas.SidePot = (function() {

        /**
         * Properties of a SidePot.
         * @memberof Texas
         * @interface ISidePot
         * @property {Array.<Texas.SidePot.IPlayer>|null} [players] SidePot players
         * @property {number|null} [totalBet] SidePot totalBet
         */

        /**
         * Constructs a new SidePot.
         * @memberof Texas
         * @classdesc Represents a SidePot.
         * @implements ISidePot
         * @constructor
         * @param {Texas.ISidePot=} [properties] Properties to set
         */
        function SidePot(properties) {
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SidePot players.
         * @member {Array.<Texas.SidePot.IPlayer>} players
         * @memberof Texas.SidePot
         * @instance
         */
        SidePot.prototype.players = $util.emptyArray;

        /**
         * SidePot totalBet.
         * @member {number} totalBet
         * @memberof Texas.SidePot
         * @instance
         */
        SidePot.prototype.totalBet = 0;

        /**
         * Creates a new SidePot instance using the specified properties.
         * @function create
         * @memberof Texas.SidePot
         * @static
         * @param {Texas.ISidePot=} [properties] Properties to set
         * @returns {Texas.SidePot} SidePot instance
         */
        SidePot.create = function create(properties) {
            return new SidePot(properties);
        };

        /**
         * Encodes the specified SidePot message. Does not implicitly {@link Texas.SidePot.verify|verify} messages.
         * @function encode
         * @memberof Texas.SidePot
         * @static
         * @param {Texas.ISidePot} message SidePot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SidePot.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Texas.SidePot.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.totalBet != null && message.hasOwnProperty("totalBet"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.totalBet);
            return writer;
        };

        /**
         * Encodes the specified SidePot message, length delimited. Does not implicitly {@link Texas.SidePot.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.SidePot
         * @static
         * @param {Texas.ISidePot} message SidePot message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SidePot.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SidePot message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.SidePot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.SidePot} SidePot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SidePot.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SidePot();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Texas.SidePot.Player.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.totalBet = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SidePot message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.SidePot
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.SidePot} SidePot
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SidePot.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SidePot message.
         * @function verify
         * @memberof Texas.SidePot
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SidePot.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Texas.SidePot.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (message.totalBet != null && message.hasOwnProperty("totalBet"))
                if (typeof message.totalBet !== "number")
                    return "totalBet: number expected";
            return null;
        };

        /**
         * Creates a SidePot message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.SidePot
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.SidePot} SidePot
         */
        SidePot.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.SidePot)
                return object;
            var message = new $root.Texas.SidePot();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Texas.SidePot.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Texas.SidePot.players: object expected");
                    message.players[i] = $root.Texas.SidePot.Player.fromObject(object.players[i]);
                }
            }
            if (object.totalBet != null)
                message.totalBet = Number(object.totalBet);
            return message;
        };

        /**
         * Creates a plain object from a SidePot message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.SidePot
         * @static
         * @param {Texas.SidePot} message SidePot
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SidePot.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.players = [];
            if (options.defaults)
                object.totalBet = 0;
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Texas.SidePot.Player.toObject(message.players[j], options);
            }
            if (message.totalBet != null && message.hasOwnProperty("totalBet"))
                object.totalBet = options.json && !isFinite(message.totalBet) ? String(message.totalBet) : message.totalBet;
            return object;
        };

        /**
         * Converts this SidePot to JSON.
         * @function toJSON
         * @memberof Texas.SidePot
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SidePot.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        SidePot.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof Texas.SidePot
             * @interface IPlayer
             * @property {number} id Player id
             * @property {number} bet Player bet
             * @property {number|null} [winLoseBet] Player winLoseBet
             * @property {number|null} [obtainChips] Player obtainChips
             * @property {number|null} [feeGold] Player feeGold
             */

            /**
             * Constructs a new Player.
             * @memberof Texas.SidePot
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {Texas.SidePot.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player id.
             * @member {number} id
             * @memberof Texas.SidePot.Player
             * @instance
             */
            Player.prototype.id = 0;

            /**
             * Player bet.
             * @member {number} bet
             * @memberof Texas.SidePot.Player
             * @instance
             */
            Player.prototype.bet = 0;

            /**
             * Player winLoseBet.
             * @member {number} winLoseBet
             * @memberof Texas.SidePot.Player
             * @instance
             */
            Player.prototype.winLoseBet = 0;

            /**
             * Player obtainChips.
             * @member {number} obtainChips
             * @memberof Texas.SidePot.Player
             * @instance
             */
            Player.prototype.obtainChips = 0;

            /**
             * Player feeGold.
             * @member {number} feeGold
             * @memberof Texas.SidePot.Player
             * @instance
             */
            Player.prototype.feeGold = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Texas.SidePot.IPlayer=} [properties] Properties to set
             * @returns {Texas.SidePot.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link Texas.SidePot.Player.verify|verify} messages.
             * @function encode
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Texas.SidePot.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.id);
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.bet);
                if (message.winLoseBet != null && message.hasOwnProperty("winLoseBet"))
                    writer.uint32(/* id 3, wireType 1 =*/25).double(message.winLoseBet);
                if (message.obtainChips != null && message.hasOwnProperty("obtainChips"))
                    writer.uint32(/* id 4, wireType 1 =*/33).double(message.obtainChips);
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.feeGold);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link Texas.SidePot.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Texas.SidePot.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof Texas.SidePot.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Texas.SidePot.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SidePot.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.id = reader.int32();
                        break;
                    case 2:
                        message.bet = reader.double();
                        break;
                    case 3:
                        message.winLoseBet = reader.double();
                        break;
                    case 4:
                        message.obtainChips = reader.double();
                        break;
                    case 5:
                        message.feeGold = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("id"))
                    throw $util.ProtocolError("missing required 'id'", { instance: message });
                if (!message.hasOwnProperty("bet"))
                    throw $util.ProtocolError("missing required 'bet'", { instance: message });
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Texas.SidePot.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Texas.SidePot.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.id))
                    return "id: integer expected";
                if (typeof message.bet !== "number")
                    return "bet: number expected";
                if (message.winLoseBet != null && message.hasOwnProperty("winLoseBet"))
                    if (typeof message.winLoseBet !== "number")
                        return "winLoseBet: number expected";
                if (message.obtainChips != null && message.hasOwnProperty("obtainChips"))
                    if (typeof message.obtainChips !== "number")
                        return "obtainChips: number expected";
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    if (typeof message.feeGold !== "number")
                        return "feeGold: number expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Texas.SidePot.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.Texas.SidePot.Player)
                    return object;
                var message = new $root.Texas.SidePot.Player();
                if (object.id != null)
                    message.id = object.id | 0;
                if (object.bet != null)
                    message.bet = Number(object.bet);
                if (object.winLoseBet != null)
                    message.winLoseBet = Number(object.winLoseBet);
                if (object.obtainChips != null)
                    message.obtainChips = Number(object.obtainChips);
                if (object.feeGold != null)
                    message.feeGold = Number(object.feeGold);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Texas.SidePot.Player
             * @static
             * @param {Texas.SidePot.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.id = 0;
                    object.bet = 0;
                    object.winLoseBet = 0;
                    object.obtainChips = 0;
                    object.feeGold = 0;
                }
                if (message.id != null && message.hasOwnProperty("id"))
                    object.id = message.id;
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
                if (message.winLoseBet != null && message.hasOwnProperty("winLoseBet"))
                    object.winLoseBet = options.json && !isFinite(message.winLoseBet) ? String(message.winLoseBet) : message.winLoseBet;
                if (message.obtainChips != null && message.hasOwnProperty("obtainChips"))
                    object.obtainChips = options.json && !isFinite(message.obtainChips) ? String(message.obtainChips) : message.obtainChips;
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    object.feeGold = options.json && !isFinite(message.feeGold) ? String(message.feeGold) : message.feeGold;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof Texas.SidePot.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return SidePot;
    })();

    Texas.Player = (function() {

        /**
         * Properties of a Player.
         * @memberof Texas
         * @interface IPlayer
         * @property {number} playerId Player playerId
         * @property {number} playerPos Player playerPos
         * @property {boolean} isOffline Player isOffline
         * @property {boolean} isOwner Player isOwner
         * @property {boolean} isReady Player isReady
         * @property {number} chips Player chips
         * @property {number} bet Player bet
         * @property {Array.<number>|null} [cards] Player cards
         * @property {number|null} [intrustState] Player intrustState
         * @property {number} state Player state
         * @property {Texas.IMaxCardInfo|null} [maxCardInfo] Player maxCardInfo
         * @property {number|null} [betStatus] Player betStatus
         * @property {number|null} [curRoundBet] Player curRoundBet
         * @property {string|null} [playerInfo] Player playerInfo
         */

        /**
         * Constructs a new Player.
         * @memberof Texas
         * @classdesc Represents a Player.
         * @implements IPlayer
         * @constructor
         * @param {Texas.IPlayer=} [properties] Properties to set
         */
        function Player(properties) {
            this.cards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Player playerId.
         * @member {number} playerId
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.playerId = 0;

        /**
         * Player playerPos.
         * @member {number} playerPos
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.playerPos = 0;

        /**
         * Player isOffline.
         * @member {boolean} isOffline
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.isOffline = false;

        /**
         * Player isOwner.
         * @member {boolean} isOwner
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.isOwner = false;

        /**
         * Player isReady.
         * @member {boolean} isReady
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.isReady = false;

        /**
         * Player chips.
         * @member {number} chips
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.chips = 0;

        /**
         * Player bet.
         * @member {number} bet
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.bet = 0;

        /**
         * Player cards.
         * @member {Array.<number>} cards
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.cards = $util.emptyArray;

        /**
         * Player intrustState.
         * @member {number} intrustState
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.intrustState = 0;

        /**
         * Player state.
         * @member {number} state
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.state = 0;

        /**
         * Player maxCardInfo.
         * @member {Texas.IMaxCardInfo|null|undefined} maxCardInfo
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.maxCardInfo = null;

        /**
         * Player betStatus.
         * @member {number} betStatus
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.betStatus = 0;

        /**
         * Player curRoundBet.
         * @member {number} curRoundBet
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.curRoundBet = 0;

        /**
         * Player playerInfo.
         * @member {string} playerInfo
         * @memberof Texas.Player
         * @instance
         */
        Player.prototype.playerInfo = "";

        /**
         * Creates a new Player instance using the specified properties.
         * @function create
         * @memberof Texas.Player
         * @static
         * @param {Texas.IPlayer=} [properties] Properties to set
         * @returns {Texas.Player} Player instance
         */
        Player.create = function create(properties) {
            return new Player(properties);
        };

        /**
         * Encodes the specified Player message. Does not implicitly {@link Texas.Player.verify|verify} messages.
         * @function encode
         * @memberof Texas.Player
         * @static
         * @param {Texas.IPlayer} message Player message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Player.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerPos);
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isOffline);
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isOwner);
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isReady);
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.chips);
            writer.uint32(/* id 7, wireType 1 =*/57).double(message.bet);
            if (message.cards != null && message.cards.length)
                for (var i = 0; i < message.cards.length; ++i)
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.cards[i]);
            if (message.intrustState != null && message.hasOwnProperty("intrustState"))
                writer.uint32(/* id 10, wireType 0 =*/80).int32(message.intrustState);
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.state);
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                $root.Texas.MaxCardInfo.encode(message.maxCardInfo, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            if (message.betStatus != null && message.hasOwnProperty("betStatus"))
                writer.uint32(/* id 13, wireType 0 =*/104).int32(message.betStatus);
            if (message.curRoundBet != null && message.hasOwnProperty("curRoundBet"))
                writer.uint32(/* id 14, wireType 1 =*/113).double(message.curRoundBet);
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.playerInfo);
            return writer;
        };

        /**
         * Encodes the specified Player message, length delimited. Does not implicitly {@link Texas.Player.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.Player
         * @static
         * @param {Texas.IPlayer} message Player message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Player.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Player message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.Player
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.Player} Player
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Player.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.Player();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.playerPos = reader.int32();
                    break;
                case 3:
                    message.isOffline = reader.bool();
                    break;
                case 4:
                    message.isOwner = reader.bool();
                    break;
                case 5:
                    message.isReady = reader.bool();
                    break;
                case 6:
                    message.chips = reader.double();
                    break;
                case 7:
                    message.bet = reader.double();
                    break;
                case 9:
                    if (!(message.cards && message.cards.length))
                        message.cards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.cards.push(reader.int32());
                    } else
                        message.cards.push(reader.int32());
                    break;
                case 10:
                    message.intrustState = reader.int32();
                    break;
                case 11:
                    message.state = reader.int32();
                    break;
                case 12:
                    message.maxCardInfo = $root.Texas.MaxCardInfo.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.betStatus = reader.int32();
                    break;
                case 14:
                    message.curRoundBet = reader.double();
                    break;
                case 15:
                    message.playerInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("playerPos"))
                throw $util.ProtocolError("missing required 'playerPos'", { instance: message });
            if (!message.hasOwnProperty("isOffline"))
                throw $util.ProtocolError("missing required 'isOffline'", { instance: message });
            if (!message.hasOwnProperty("isOwner"))
                throw $util.ProtocolError("missing required 'isOwner'", { instance: message });
            if (!message.hasOwnProperty("isReady"))
                throw $util.ProtocolError("missing required 'isReady'", { instance: message });
            if (!message.hasOwnProperty("chips"))
                throw $util.ProtocolError("missing required 'chips'", { instance: message });
            if (!message.hasOwnProperty("bet"))
                throw $util.ProtocolError("missing required 'bet'", { instance: message });
            if (!message.hasOwnProperty("state"))
                throw $util.ProtocolError("missing required 'state'", { instance: message });
            return message;
        };

        /**
         * Decodes a Player message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.Player
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.Player} Player
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Player.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Player message.
         * @function verify
         * @memberof Texas.Player
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Player.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (!$util.isInteger(message.playerPos))
                return "playerPos: integer expected";
            if (typeof message.isOffline !== "boolean")
                return "isOffline: boolean expected";
            if (typeof message.isOwner !== "boolean")
                return "isOwner: boolean expected";
            if (typeof message.isReady !== "boolean")
                return "isReady: boolean expected";
            if (typeof message.chips !== "number")
                return "chips: number expected";
            if (typeof message.bet !== "number")
                return "bet: number expected";
            if (message.cards != null && message.hasOwnProperty("cards")) {
                if (!Array.isArray(message.cards))
                    return "cards: array expected";
                for (var i = 0; i < message.cards.length; ++i)
                    if (!$util.isInteger(message.cards[i]))
                        return "cards: integer[] expected";
            }
            if (message.intrustState != null && message.hasOwnProperty("intrustState"))
                if (!$util.isInteger(message.intrustState))
                    return "intrustState: integer expected";
            if (!$util.isInteger(message.state))
                return "state: integer expected";
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo")) {
                var error = $root.Texas.MaxCardInfo.verify(message.maxCardInfo);
                if (error)
                    return "maxCardInfo." + error;
            }
            if (message.betStatus != null && message.hasOwnProperty("betStatus"))
                if (!$util.isInteger(message.betStatus))
                    return "betStatus: integer expected";
            if (message.curRoundBet != null && message.hasOwnProperty("curRoundBet"))
                if (typeof message.curRoundBet !== "number")
                    return "curRoundBet: number expected";
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                if (!$util.isString(message.playerInfo))
                    return "playerInfo: string expected";
            return null;
        };

        /**
         * Creates a Player message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.Player
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.Player} Player
         */
        Player.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.Player)
                return object;
            var message = new $root.Texas.Player();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.playerPos != null)
                message.playerPos = object.playerPos | 0;
            if (object.isOffline != null)
                message.isOffline = Boolean(object.isOffline);
            if (object.isOwner != null)
                message.isOwner = Boolean(object.isOwner);
            if (object.isReady != null)
                message.isReady = Boolean(object.isReady);
            if (object.chips != null)
                message.chips = Number(object.chips);
            if (object.bet != null)
                message.bet = Number(object.bet);
            if (object.cards) {
                if (!Array.isArray(object.cards))
                    throw TypeError(".Texas.Player.cards: array expected");
                message.cards = [];
                for (var i = 0; i < object.cards.length; ++i)
                    message.cards[i] = object.cards[i] | 0;
            }
            if (object.intrustState != null)
                message.intrustState = object.intrustState | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.maxCardInfo != null) {
                if (typeof object.maxCardInfo !== "object")
                    throw TypeError(".Texas.Player.maxCardInfo: object expected");
                message.maxCardInfo = $root.Texas.MaxCardInfo.fromObject(object.maxCardInfo);
            }
            if (object.betStatus != null)
                message.betStatus = object.betStatus | 0;
            if (object.curRoundBet != null)
                message.curRoundBet = Number(object.curRoundBet);
            if (object.playerInfo != null)
                message.playerInfo = String(object.playerInfo);
            return message;
        };

        /**
         * Creates a plain object from a Player message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.Player
         * @static
         * @param {Texas.Player} message Player
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Player.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.cards = [];
            if (options.defaults) {
                object.playerId = 0;
                object.playerPos = 0;
                object.isOffline = false;
                object.isOwner = false;
                object.isReady = false;
                object.chips = 0;
                object.bet = 0;
                object.intrustState = 0;
                object.state = 0;
                object.maxCardInfo = null;
                object.betStatus = 0;
                object.curRoundBet = 0;
                object.playerInfo = "";
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                object.playerPos = message.playerPos;
            if (message.isOffline != null && message.hasOwnProperty("isOffline"))
                object.isOffline = message.isOffline;
            if (message.isOwner != null && message.hasOwnProperty("isOwner"))
                object.isOwner = message.isOwner;
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                object.isReady = message.isReady;
            if (message.chips != null && message.hasOwnProperty("chips"))
                object.chips = options.json && !isFinite(message.chips) ? String(message.chips) : message.chips;
            if (message.bet != null && message.hasOwnProperty("bet"))
                object.bet = options.json && !isFinite(message.bet) ? String(message.bet) : message.bet;
            if (message.cards && message.cards.length) {
                object.cards = [];
                for (var j = 0; j < message.cards.length; ++j)
                    object.cards[j] = message.cards[j];
            }
            if (message.intrustState != null && message.hasOwnProperty("intrustState"))
                object.intrustState = message.intrustState;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                object.maxCardInfo = $root.Texas.MaxCardInfo.toObject(message.maxCardInfo, options);
            if (message.betStatus != null && message.hasOwnProperty("betStatus"))
                object.betStatus = message.betStatus;
            if (message.curRoundBet != null && message.hasOwnProperty("curRoundBet"))
                object.curRoundBet = options.json && !isFinite(message.curRoundBet) ? String(message.curRoundBet) : message.curRoundBet;
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                object.playerInfo = message.playerInfo;
            return object;
        };

        /**
         * Converts this Player to JSON.
         * @function toJSON
         * @memberof Texas.Player
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Player.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Player;
    })();

    Texas.GameInfo = (function() {

        /**
         * Properties of a GameInfo.
         * @memberof Texas
         * @interface IGameInfo
         * @property {number} roomId GameInfo roomId
         * @property {Array.<Texas.IPlayer>|null} [players] GameInfo players
         * @property {number} maxPlayerCount GameInfo maxPlayerCount
         * @property {number} minPlayerCount GameInfo minPlayerCount
         * @property {number} currentRound GameInfo currentRound
         * @property {number} totalRound GameInfo totalRound
         * @property {number|null} [banker] GameInfo banker
         * @property {number|null} [smallBlind] GameInfo smallBlind
         * @property {number|null} [bigBlind] GameInfo bigBlind
         * @property {Array.<number>|null} [publicCards] GameInfo publicCards
         * @property {Texas.ILastAction|null} [lastAction] GameInfo lastAction
         * @property {Texas.INextAction|null} [nextAction] GameInfo nextAction
         * @property {Texas.IGameState} gameState GameInfo gameState
         * @property {number|null} [baseBet] GameInfo baseBet
         * @property {number|null} [bigBet] GameInfo bigBet
         * @property {number|null} [autoReadyTime] GameInfo autoReadyTime
         * @property {number} selfPos GameInfo selfPos
         * @property {number|null} [pot] GameInfo pot
         * @property {Array.<number>|null} [observers] GameInfo observers
         * @property {Array.<Texas.ISidePot>|null} [sidePots] GameInfo sidePots
         * @property {number|null} [nextRoundStartTime] GameInfo nextRoundStartTime
         * @property {Array.<Texas.GameInfo.IPosInfo>|null} [posInfo] GameInfo posInfo
         * @property {number|null} [minJoinCoin] GameInfo minJoinCoin
         * @property {number|null} [maxJoinCoin] GameInfo maxJoinCoin
         * @property {boolean|null} [needRecharge] GameInfo needRecharge
         * @property {number|null} [coinStatus] GameInfo coinStatus
         * @property {string|null} [roundNo] GameInfo roundNo
         */

        /**
         * Constructs a new GameInfo.
         * @memberof Texas
         * @classdesc Represents a GameInfo.
         * @implements IGameInfo
         * @constructor
         * @param {Texas.IGameInfo=} [properties] Properties to set
         */
        function GameInfo(properties) {
            this.players = [];
            this.publicCards = [];
            this.observers = [];
            this.sidePots = [];
            this.posInfo = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameInfo roomId.
         * @member {number} roomId
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.roomId = 0;

        /**
         * GameInfo players.
         * @member {Array.<Texas.IPlayer>} players
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.players = $util.emptyArray;

        /**
         * GameInfo maxPlayerCount.
         * @member {number} maxPlayerCount
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.maxPlayerCount = 0;

        /**
         * GameInfo minPlayerCount.
         * @member {number} minPlayerCount
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.minPlayerCount = 0;

        /**
         * GameInfo currentRound.
         * @member {number} currentRound
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.currentRound = 0;

        /**
         * GameInfo totalRound.
         * @member {number} totalRound
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.totalRound = 0;

        /**
         * GameInfo banker.
         * @member {number} banker
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.banker = 0;

        /**
         * GameInfo smallBlind.
         * @member {number} smallBlind
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.smallBlind = 0;

        /**
         * GameInfo bigBlind.
         * @member {number} bigBlind
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.bigBlind = 0;

        /**
         * GameInfo publicCards.
         * @member {Array.<number>} publicCards
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.publicCards = $util.emptyArray;

        /**
         * GameInfo lastAction.
         * @member {Texas.ILastAction|null|undefined} lastAction
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.lastAction = null;

        /**
         * GameInfo nextAction.
         * @member {Texas.INextAction|null|undefined} nextAction
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.nextAction = null;

        /**
         * GameInfo gameState.
         * @member {Texas.IGameState} gameState
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.gameState = null;

        /**
         * GameInfo baseBet.
         * @member {number} baseBet
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.baseBet = 0;

        /**
         * GameInfo bigBet.
         * @member {number} bigBet
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.bigBet = 0;

        /**
         * GameInfo autoReadyTime.
         * @member {number} autoReadyTime
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.autoReadyTime = 0;

        /**
         * GameInfo selfPos.
         * @member {number} selfPos
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.selfPos = 0;

        /**
         * GameInfo pot.
         * @member {number} pot
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.pot = 0;

        /**
         * GameInfo observers.
         * @member {Array.<number>} observers
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.observers = $util.emptyArray;

        /**
         * GameInfo sidePots.
         * @member {Array.<Texas.ISidePot>} sidePots
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.sidePots = $util.emptyArray;

        /**
         * GameInfo nextRoundStartTime.
         * @member {number} nextRoundStartTime
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.nextRoundStartTime = 0;

        /**
         * GameInfo posInfo.
         * @member {Array.<Texas.GameInfo.IPosInfo>} posInfo
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.posInfo = $util.emptyArray;

        /**
         * GameInfo minJoinCoin.
         * @member {number} minJoinCoin
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.minJoinCoin = 0;

        /**
         * GameInfo maxJoinCoin.
         * @member {number} maxJoinCoin
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.maxJoinCoin = 0;

        /**
         * GameInfo needRecharge.
         * @member {boolean} needRecharge
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.needRecharge = false;

        /**
         * GameInfo coinStatus.
         * @member {number} coinStatus
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.coinStatus = 0;

        /**
         * GameInfo roundNo.
         * @member {string} roundNo
         * @memberof Texas.GameInfo
         * @instance
         */
        GameInfo.prototype.roundNo = "";

        /**
         * Creates a new GameInfo instance using the specified properties.
         * @function create
         * @memberof Texas.GameInfo
         * @static
         * @param {Texas.IGameInfo=} [properties] Properties to set
         * @returns {Texas.GameInfo} GameInfo instance
         */
        GameInfo.create = function create(properties) {
            return new GameInfo(properties);
        };

        /**
         * Encodes the specified GameInfo message. Does not implicitly {@link Texas.GameInfo.verify|verify} messages.
         * @function encode
         * @memberof Texas.GameInfo
         * @static
         * @param {Texas.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Texas.Player.encode(message.players[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxPlayerCount);
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minPlayerCount);
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.currentRound);
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.totalRound);
            if (message.banker != null && message.hasOwnProperty("banker"))
                writer.uint32(/* id 7, wireType 0 =*/56).int32(message.banker);
            if (message.smallBlind != null && message.hasOwnProperty("smallBlind"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.smallBlind);
            if (message.bigBlind != null && message.hasOwnProperty("bigBlind"))
                writer.uint32(/* id 9, wireType 0 =*/72).int32(message.bigBlind);
            if (message.publicCards != null && message.publicCards.length)
                for (var i = 0; i < message.publicCards.length; ++i)
                    writer.uint32(/* id 10, wireType 0 =*/80).int32(message.publicCards[i]);
            if (message.lastAction != null && message.hasOwnProperty("lastAction"))
                $root.Texas.LastAction.encode(message.lastAction, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
            if (message.nextAction != null && message.hasOwnProperty("nextAction"))
                $root.Texas.NextAction.encode(message.nextAction, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
            $root.Texas.GameState.encode(message.gameState, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
            if (message.baseBet != null && message.hasOwnProperty("baseBet"))
                writer.uint32(/* id 14, wireType 0 =*/112).int32(message.baseBet);
            if (message.bigBet != null && message.hasOwnProperty("bigBet"))
                writer.uint32(/* id 15, wireType 0 =*/120).int32(message.bigBet);
            if (message.autoReadyTime != null && message.hasOwnProperty("autoReadyTime"))
                writer.uint32(/* id 16, wireType 0 =*/128).int32(message.autoReadyTime);
            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.selfPos);
            if (message.pot != null && message.hasOwnProperty("pot"))
                writer.uint32(/* id 19, wireType 1 =*/153).double(message.pot);
            if (message.observers != null && message.observers.length)
                for (var i = 0; i < message.observers.length; ++i)
                    writer.uint32(/* id 20, wireType 0 =*/160).int32(message.observers[i]);
            if (message.sidePots != null && message.sidePots.length)
                for (var i = 0; i < message.sidePots.length; ++i)
                    $root.Texas.SidePot.encode(message.sidePots[i], writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                writer.uint32(/* id 22, wireType 0 =*/176).int32(message.nextRoundStartTime);
            if (message.posInfo != null && message.posInfo.length)
                for (var i = 0; i < message.posInfo.length; ++i)
                    $root.Texas.GameInfo.PosInfo.encode(message.posInfo[i], writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
            if (message.minJoinCoin != null && message.hasOwnProperty("minJoinCoin"))
                writer.uint32(/* id 24, wireType 0 =*/192).int32(message.minJoinCoin);
            if (message.maxJoinCoin != null && message.hasOwnProperty("maxJoinCoin"))
                writer.uint32(/* id 25, wireType 0 =*/200).int32(message.maxJoinCoin);
            if (message.needRecharge != null && message.hasOwnProperty("needRecharge"))
                writer.uint32(/* id 26, wireType 0 =*/208).bool(message.needRecharge);
            if (message.coinStatus != null && message.hasOwnProperty("coinStatus"))
                writer.uint32(/* id 27, wireType 0 =*/216).int32(message.coinStatus);
            if (message.roundNo != null && message.hasOwnProperty("roundNo"))
                writer.uint32(/* id 28, wireType 2 =*/226).string(message.roundNo);
            return writer;
        };

        /**
         * Encodes the specified GameInfo message, length delimited. Does not implicitly {@link Texas.GameInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.GameInfo
         * @static
         * @param {Texas.IGameInfo} message GameInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 2:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Texas.Player.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.maxPlayerCount = reader.int32();
                    break;
                case 4:
                    message.minPlayerCount = reader.int32();
                    break;
                case 5:
                    message.currentRound = reader.int32();
                    break;
                case 6:
                    message.totalRound = reader.int32();
                    break;
                case 7:
                    message.banker = reader.int32();
                    break;
                case 8:
                    message.smallBlind = reader.int32();
                    break;
                case 9:
                    message.bigBlind = reader.int32();
                    break;
                case 10:
                    if (!(message.publicCards && message.publicCards.length))
                        message.publicCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.publicCards.push(reader.int32());
                    } else
                        message.publicCards.push(reader.int32());
                    break;
                case 11:
                    message.lastAction = $root.Texas.LastAction.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.nextAction = $root.Texas.NextAction.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.gameState = $root.Texas.GameState.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.baseBet = reader.int32();
                    break;
                case 15:
                    message.bigBet = reader.int32();
                    break;
                case 16:
                    message.autoReadyTime = reader.int32();
                    break;
                case 18:
                    message.selfPos = reader.int32();
                    break;
                case 19:
                    message.pot = reader.double();
                    break;
                case 20:
                    if (!(message.observers && message.observers.length))
                        message.observers = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.observers.push(reader.int32());
                    } else
                        message.observers.push(reader.int32());
                    break;
                case 21:
                    if (!(message.sidePots && message.sidePots.length))
                        message.sidePots = [];
                    message.sidePots.push($root.Texas.SidePot.decode(reader, reader.uint32()));
                    break;
                case 22:
                    message.nextRoundStartTime = reader.int32();
                    break;
                case 23:
                    if (!(message.posInfo && message.posInfo.length))
                        message.posInfo = [];
                    message.posInfo.push($root.Texas.GameInfo.PosInfo.decode(reader, reader.uint32()));
                    break;
                case 24:
                    message.minJoinCoin = reader.int32();
                    break;
                case 25:
                    message.maxJoinCoin = reader.int32();
                    break;
                case 26:
                    message.needRecharge = reader.bool();
                    break;
                case 27:
                    message.coinStatus = reader.int32();
                    break;
                case 28:
                    message.roundNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("roomId"))
                throw $util.ProtocolError("missing required 'roomId'", { instance: message });
            if (!message.hasOwnProperty("maxPlayerCount"))
                throw $util.ProtocolError("missing required 'maxPlayerCount'", { instance: message });
            if (!message.hasOwnProperty("minPlayerCount"))
                throw $util.ProtocolError("missing required 'minPlayerCount'", { instance: message });
            if (!message.hasOwnProperty("currentRound"))
                throw $util.ProtocolError("missing required 'currentRound'", { instance: message });
            if (!message.hasOwnProperty("totalRound"))
                throw $util.ProtocolError("missing required 'totalRound'", { instance: message });
            if (!message.hasOwnProperty("gameState"))
                throw $util.ProtocolError("missing required 'gameState'", { instance: message });
            if (!message.hasOwnProperty("selfPos"))
                throw $util.ProtocolError("missing required 'selfPos'", { instance: message });
            return message;
        };

        /**
         * Decodes a GameInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.GameInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.GameInfo} GameInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameInfo message.
         * @function verify
         * @memberof Texas.GameInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.roomId))
                return "roomId: integer expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Texas.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (!$util.isInteger(message.maxPlayerCount))
                return "maxPlayerCount: integer expected";
            if (!$util.isInteger(message.minPlayerCount))
                return "minPlayerCount: integer expected";
            if (!$util.isInteger(message.currentRound))
                return "currentRound: integer expected";
            if (!$util.isInteger(message.totalRound))
                return "totalRound: integer expected";
            if (message.banker != null && message.hasOwnProperty("banker"))
                if (!$util.isInteger(message.banker))
                    return "banker: integer expected";
            if (message.smallBlind != null && message.hasOwnProperty("smallBlind"))
                if (!$util.isInteger(message.smallBlind))
                    return "smallBlind: integer expected";
            if (message.bigBlind != null && message.hasOwnProperty("bigBlind"))
                if (!$util.isInteger(message.bigBlind))
                    return "bigBlind: integer expected";
            if (message.publicCards != null && message.hasOwnProperty("publicCards")) {
                if (!Array.isArray(message.publicCards))
                    return "publicCards: array expected";
                for (var i = 0; i < message.publicCards.length; ++i)
                    if (!$util.isInteger(message.publicCards[i]))
                        return "publicCards: integer[] expected";
            }
            if (message.lastAction != null && message.hasOwnProperty("lastAction")) {
                var error = $root.Texas.LastAction.verify(message.lastAction);
                if (error)
                    return "lastAction." + error;
            }
            if (message.nextAction != null && message.hasOwnProperty("nextAction")) {
                var error = $root.Texas.NextAction.verify(message.nextAction);
                if (error)
                    return "nextAction." + error;
            }
            {
                var error = $root.Texas.GameState.verify(message.gameState);
                if (error)
                    return "gameState." + error;
            }
            if (message.baseBet != null && message.hasOwnProperty("baseBet"))
                if (!$util.isInteger(message.baseBet))
                    return "baseBet: integer expected";
            if (message.bigBet != null && message.hasOwnProperty("bigBet"))
                if (!$util.isInteger(message.bigBet))
                    return "bigBet: integer expected";
            if (message.autoReadyTime != null && message.hasOwnProperty("autoReadyTime"))
                if (!$util.isInteger(message.autoReadyTime))
                    return "autoReadyTime: integer expected";
            if (!$util.isInteger(message.selfPos))
                return "selfPos: integer expected";
            if (message.pot != null && message.hasOwnProperty("pot"))
                if (typeof message.pot !== "number")
                    return "pot: number expected";
            if (message.observers != null && message.hasOwnProperty("observers")) {
                if (!Array.isArray(message.observers))
                    return "observers: array expected";
                for (var i = 0; i < message.observers.length; ++i)
                    if (!$util.isInteger(message.observers[i]))
                        return "observers: integer[] expected";
            }
            if (message.sidePots != null && message.hasOwnProperty("sidePots")) {
                if (!Array.isArray(message.sidePots))
                    return "sidePots: array expected";
                for (var i = 0; i < message.sidePots.length; ++i) {
                    var error = $root.Texas.SidePot.verify(message.sidePots[i]);
                    if (error)
                        return "sidePots." + error;
                }
            }
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                if (!$util.isInteger(message.nextRoundStartTime))
                    return "nextRoundStartTime: integer expected";
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                if (!Array.isArray(message.posInfo))
                    return "posInfo: array expected";
                for (var i = 0; i < message.posInfo.length; ++i) {
                    var error = $root.Texas.GameInfo.PosInfo.verify(message.posInfo[i]);
                    if (error)
                        return "posInfo." + error;
                }
            }
            if (message.minJoinCoin != null && message.hasOwnProperty("minJoinCoin"))
                if (!$util.isInteger(message.minJoinCoin))
                    return "minJoinCoin: integer expected";
            if (message.maxJoinCoin != null && message.hasOwnProperty("maxJoinCoin"))
                if (!$util.isInteger(message.maxJoinCoin))
                    return "maxJoinCoin: integer expected";
            if (message.needRecharge != null && message.hasOwnProperty("needRecharge"))
                if (typeof message.needRecharge !== "boolean")
                    return "needRecharge: boolean expected";
            if (message.coinStatus != null && message.hasOwnProperty("coinStatus"))
                if (!$util.isInteger(message.coinStatus))
                    return "coinStatus: integer expected";
            if (message.roundNo != null && message.hasOwnProperty("roundNo"))
                if (!$util.isString(message.roundNo))
                    return "roundNo: string expected";
            return null;
        };

        /**
         * Creates a GameInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.GameInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.GameInfo} GameInfo
         */
        GameInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.GameInfo)
                return object;
            var message = new $root.Texas.GameInfo();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Texas.GameInfo.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Texas.GameInfo.players: object expected");
                    message.players[i] = $root.Texas.Player.fromObject(object.players[i]);
                }
            }
            if (object.maxPlayerCount != null)
                message.maxPlayerCount = object.maxPlayerCount | 0;
            if (object.minPlayerCount != null)
                message.minPlayerCount = object.minPlayerCount | 0;
            if (object.currentRound != null)
                message.currentRound = object.currentRound | 0;
            if (object.totalRound != null)
                message.totalRound = object.totalRound | 0;
            if (object.banker != null)
                message.banker = object.banker | 0;
            if (object.smallBlind != null)
                message.smallBlind = object.smallBlind | 0;
            if (object.bigBlind != null)
                message.bigBlind = object.bigBlind | 0;
            if (object.publicCards) {
                if (!Array.isArray(object.publicCards))
                    throw TypeError(".Texas.GameInfo.publicCards: array expected");
                message.publicCards = [];
                for (var i = 0; i < object.publicCards.length; ++i)
                    message.publicCards[i] = object.publicCards[i] | 0;
            }
            if (object.lastAction != null) {
                if (typeof object.lastAction !== "object")
                    throw TypeError(".Texas.GameInfo.lastAction: object expected");
                message.lastAction = $root.Texas.LastAction.fromObject(object.lastAction);
            }
            if (object.nextAction != null) {
                if (typeof object.nextAction !== "object")
                    throw TypeError(".Texas.GameInfo.nextAction: object expected");
                message.nextAction = $root.Texas.NextAction.fromObject(object.nextAction);
            }
            if (object.gameState != null) {
                if (typeof object.gameState !== "object")
                    throw TypeError(".Texas.GameInfo.gameState: object expected");
                message.gameState = $root.Texas.GameState.fromObject(object.gameState);
            }
            if (object.baseBet != null)
                message.baseBet = object.baseBet | 0;
            if (object.bigBet != null)
                message.bigBet = object.bigBet | 0;
            if (object.autoReadyTime != null)
                message.autoReadyTime = object.autoReadyTime | 0;
            if (object.selfPos != null)
                message.selfPos = object.selfPos | 0;
            if (object.pot != null)
                message.pot = Number(object.pot);
            if (object.observers) {
                if (!Array.isArray(object.observers))
                    throw TypeError(".Texas.GameInfo.observers: array expected");
                message.observers = [];
                for (var i = 0; i < object.observers.length; ++i)
                    message.observers[i] = object.observers[i] | 0;
            }
            if (object.sidePots) {
                if (!Array.isArray(object.sidePots))
                    throw TypeError(".Texas.GameInfo.sidePots: array expected");
                message.sidePots = [];
                for (var i = 0; i < object.sidePots.length; ++i) {
                    if (typeof object.sidePots[i] !== "object")
                        throw TypeError(".Texas.GameInfo.sidePots: object expected");
                    message.sidePots[i] = $root.Texas.SidePot.fromObject(object.sidePots[i]);
                }
            }
            if (object.nextRoundStartTime != null)
                message.nextRoundStartTime = object.nextRoundStartTime | 0;
            if (object.posInfo) {
                if (!Array.isArray(object.posInfo))
                    throw TypeError(".Texas.GameInfo.posInfo: array expected");
                message.posInfo = [];
                for (var i = 0; i < object.posInfo.length; ++i) {
                    if (typeof object.posInfo[i] !== "object")
                        throw TypeError(".Texas.GameInfo.posInfo: object expected");
                    message.posInfo[i] = $root.Texas.GameInfo.PosInfo.fromObject(object.posInfo[i]);
                }
            }
            if (object.minJoinCoin != null)
                message.minJoinCoin = object.minJoinCoin | 0;
            if (object.maxJoinCoin != null)
                message.maxJoinCoin = object.maxJoinCoin | 0;
            if (object.needRecharge != null)
                message.needRecharge = Boolean(object.needRecharge);
            if (object.coinStatus != null)
                message.coinStatus = object.coinStatus | 0;
            if (object.roundNo != null)
                message.roundNo = String(object.roundNo);
            return message;
        };

        /**
         * Creates a plain object from a GameInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.GameInfo
         * @static
         * @param {Texas.GameInfo} message GameInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.players = [];
                object.publicCards = [];
                object.observers = [];
                object.sidePots = [];
                object.posInfo = [];
            }
            if (options.defaults) {
                object.roomId = 0;
                object.maxPlayerCount = 0;
                object.minPlayerCount = 0;
                object.currentRound = 0;
                object.totalRound = 0;
                object.banker = 0;
                object.smallBlind = 0;
                object.bigBlind = 0;
                object.lastAction = null;
                object.nextAction = null;
                object.gameState = null;
                object.baseBet = 0;
                object.bigBet = 0;
                object.autoReadyTime = 0;
                object.selfPos = 0;
                object.pot = 0;
                object.nextRoundStartTime = 0;
                object.minJoinCoin = 0;
                object.maxJoinCoin = 0;
                object.needRecharge = false;
                object.coinStatus = 0;
                object.roundNo = "";
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Texas.Player.toObject(message.players[j], options);
            }
            if (message.maxPlayerCount != null && message.hasOwnProperty("maxPlayerCount"))
                object.maxPlayerCount = message.maxPlayerCount;
            if (message.minPlayerCount != null && message.hasOwnProperty("minPlayerCount"))
                object.minPlayerCount = message.minPlayerCount;
            if (message.currentRound != null && message.hasOwnProperty("currentRound"))
                object.currentRound = message.currentRound;
            if (message.totalRound != null && message.hasOwnProperty("totalRound"))
                object.totalRound = message.totalRound;
            if (message.banker != null && message.hasOwnProperty("banker"))
                object.banker = message.banker;
            if (message.smallBlind != null && message.hasOwnProperty("smallBlind"))
                object.smallBlind = message.smallBlind;
            if (message.bigBlind != null && message.hasOwnProperty("bigBlind"))
                object.bigBlind = message.bigBlind;
            if (message.publicCards && message.publicCards.length) {
                object.publicCards = [];
                for (var j = 0; j < message.publicCards.length; ++j)
                    object.publicCards[j] = message.publicCards[j];
            }
            if (message.lastAction != null && message.hasOwnProperty("lastAction"))
                object.lastAction = $root.Texas.LastAction.toObject(message.lastAction, options);
            if (message.nextAction != null && message.hasOwnProperty("nextAction"))
                object.nextAction = $root.Texas.NextAction.toObject(message.nextAction, options);
            if (message.gameState != null && message.hasOwnProperty("gameState"))
                object.gameState = $root.Texas.GameState.toObject(message.gameState, options);
            if (message.baseBet != null && message.hasOwnProperty("baseBet"))
                object.baseBet = message.baseBet;
            if (message.bigBet != null && message.hasOwnProperty("bigBet"))
                object.bigBet = message.bigBet;
            if (message.autoReadyTime != null && message.hasOwnProperty("autoReadyTime"))
                object.autoReadyTime = message.autoReadyTime;
            if (message.selfPos != null && message.hasOwnProperty("selfPos"))
                object.selfPos = message.selfPos;
            if (message.pot != null && message.hasOwnProperty("pot"))
                object.pot = options.json && !isFinite(message.pot) ? String(message.pot) : message.pot;
            if (message.observers && message.observers.length) {
                object.observers = [];
                for (var j = 0; j < message.observers.length; ++j)
                    object.observers[j] = message.observers[j];
            }
            if (message.sidePots && message.sidePots.length) {
                object.sidePots = [];
                for (var j = 0; j < message.sidePots.length; ++j)
                    object.sidePots[j] = $root.Texas.SidePot.toObject(message.sidePots[j], options);
            }
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                object.nextRoundStartTime = message.nextRoundStartTime;
            if (message.posInfo && message.posInfo.length) {
                object.posInfo = [];
                for (var j = 0; j < message.posInfo.length; ++j)
                    object.posInfo[j] = $root.Texas.GameInfo.PosInfo.toObject(message.posInfo[j], options);
            }
            if (message.minJoinCoin != null && message.hasOwnProperty("minJoinCoin"))
                object.minJoinCoin = message.minJoinCoin;
            if (message.maxJoinCoin != null && message.hasOwnProperty("maxJoinCoin"))
                object.maxJoinCoin = message.maxJoinCoin;
            if (message.needRecharge != null && message.hasOwnProperty("needRecharge"))
                object.needRecharge = message.needRecharge;
            if (message.coinStatus != null && message.hasOwnProperty("coinStatus"))
                object.coinStatus = message.coinStatus;
            if (message.roundNo != null && message.hasOwnProperty("roundNo"))
                object.roundNo = message.roundNo;
            return object;
        };

        /**
         * Converts this GameInfo to JSON.
         * @function toJSON
         * @memberof Texas.GameInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GameInfo.PosInfo = (function() {

            /**
             * Properties of a PosInfo.
             * @memberof Texas.GameInfo
             * @interface IPosInfo
             * @property {number} pos PosInfo pos
             * @property {number|null} [bet] PosInfo bet
             */

            /**
             * Constructs a new PosInfo.
             * @memberof Texas.GameInfo
             * @classdesc Represents a PosInfo.
             * @implements IPosInfo
             * @constructor
             * @param {Texas.GameInfo.IPosInfo=} [properties] Properties to set
             */
            function PosInfo(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PosInfo pos.
             * @member {number} pos
             * @memberof Texas.GameInfo.PosInfo
             * @instance
             */
            PosInfo.prototype.pos = 0;

            /**
             * PosInfo bet.
             * @member {number} bet
             * @memberof Texas.GameInfo.PosInfo
             * @instance
             */
            PosInfo.prototype.bet = 0;

            /**
             * Creates a new PosInfo instance using the specified properties.
             * @function create
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Texas.GameInfo.IPosInfo=} [properties] Properties to set
             * @returns {Texas.GameInfo.PosInfo} PosInfo instance
             */
            PosInfo.create = function create(properties) {
                return new PosInfo(properties);
            };

            /**
             * Encodes the specified PosInfo message. Does not implicitly {@link Texas.GameInfo.PosInfo.verify|verify} messages.
             * @function encode
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Texas.GameInfo.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pos);
                if (message.bet != null && message.hasOwnProperty("bet"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.bet);
                return writer;
            };

            /**
             * Encodes the specified PosInfo message, length delimited. Does not implicitly {@link Texas.GameInfo.PosInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Texas.GameInfo.IPosInfo} message PosInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PosInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer.
             * @function decode
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Texas.GameInfo.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameInfo.PosInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.pos = reader.int32();
                        break;
                    case 2:
                        message.bet = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("pos"))
                    throw $util.ProtocolError("missing required 'pos'", { instance: message });
                return message;
            };

            /**
             * Decodes a PosInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Texas.GameInfo.PosInfo} PosInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PosInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PosInfo message.
             * @function verify
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PosInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.pos))
                    return "pos: integer expected";
                if (message.bet != null && message.hasOwnProperty("bet"))
                    if (!$util.isInteger(message.bet))
                        return "bet: integer expected";
                return null;
            };

            /**
             * Creates a PosInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Texas.GameInfo.PosInfo} PosInfo
             */
            PosInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.Texas.GameInfo.PosInfo)
                    return object;
                var message = new $root.Texas.GameInfo.PosInfo();
                if (object.pos != null)
                    message.pos = object.pos | 0;
                if (object.bet != null)
                    message.bet = object.bet | 0;
                return message;
            };

            /**
             * Creates a plain object from a PosInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Texas.GameInfo.PosInfo
             * @static
             * @param {Texas.GameInfo.PosInfo} message PosInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PosInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.pos = 0;
                    object.bet = 0;
                }
                if (message.pos != null && message.hasOwnProperty("pos"))
                    object.pos = message.pos;
                if (message.bet != null && message.hasOwnProperty("bet"))
                    object.bet = message.bet;
                return object;
            };

            /**
             * Converts this PosInfo to JSON.
             * @function toJSON
             * @memberof Texas.GameInfo.PosInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PosInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return PosInfo;
        })();

        return GameInfo;
    })();

    Texas.NeedRecharge = (function() {

        /**
         * Properties of a NeedRecharge.
         * @memberof Texas
         * @interface INeedRecharge
         */

        /**
         * Constructs a new NeedRecharge.
         * @memberof Texas
         * @classdesc Represents a NeedRecharge.
         * @implements INeedRecharge
         * @constructor
         * @param {Texas.INeedRecharge=} [properties] Properties to set
         */
        function NeedRecharge(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new NeedRecharge instance using the specified properties.
         * @function create
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Texas.INeedRecharge=} [properties] Properties to set
         * @returns {Texas.NeedRecharge} NeedRecharge instance
         */
        NeedRecharge.create = function create(properties) {
            return new NeedRecharge(properties);
        };

        /**
         * Encodes the specified NeedRecharge message. Does not implicitly {@link Texas.NeedRecharge.verify|verify} messages.
         * @function encode
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Texas.INeedRecharge} message NeedRecharge message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NeedRecharge.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified NeedRecharge message, length delimited. Does not implicitly {@link Texas.NeedRecharge.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Texas.INeedRecharge} message NeedRecharge message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        NeedRecharge.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a NeedRecharge message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.NeedRecharge
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.NeedRecharge} NeedRecharge
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NeedRecharge.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.NeedRecharge();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a NeedRecharge message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.NeedRecharge
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.NeedRecharge} NeedRecharge
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        NeedRecharge.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a NeedRecharge message.
         * @function verify
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        NeedRecharge.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a NeedRecharge message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.NeedRecharge} NeedRecharge
         */
        NeedRecharge.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.NeedRecharge)
                return object;
            return new $root.Texas.NeedRecharge();
        };

        /**
         * Creates a plain object from a NeedRecharge message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.NeedRecharge
         * @static
         * @param {Texas.NeedRecharge} message NeedRecharge
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        NeedRecharge.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this NeedRecharge to JSON.
         * @function toJSON
         * @memberof Texas.NeedRecharge
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        NeedRecharge.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NeedRecharge;
    })();

    Texas.GameState = (function() {

        /**
         * Properties of a GameState.
         * @memberof Texas
         * @interface IGameState
         * @property {number} state GameState state
         * @property {number|null} [dealPai] GameState dealPai
         * @property {Texas.IGameSettlement|null} [gameSettlement] GameState gameSettlement
         */

        /**
         * Constructs a new GameState.
         * @memberof Texas
         * @classdesc Represents a GameState.
         * @implements IGameState
         * @constructor
         * @param {Texas.IGameState=} [properties] Properties to set
         */
        function GameState(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameState state.
         * @member {number} state
         * @memberof Texas.GameState
         * @instance
         */
        GameState.prototype.state = 0;

        /**
         * GameState dealPai.
         * @member {number} dealPai
         * @memberof Texas.GameState
         * @instance
         */
        GameState.prototype.dealPai = 0;

        /**
         * GameState gameSettlement.
         * @member {Texas.IGameSettlement|null|undefined} gameSettlement
         * @memberof Texas.GameState
         * @instance
         */
        GameState.prototype.gameSettlement = null;

        /**
         * Creates a new GameState instance using the specified properties.
         * @function create
         * @memberof Texas.GameState
         * @static
         * @param {Texas.IGameState=} [properties] Properties to set
         * @returns {Texas.GameState} GameState instance
         */
        GameState.create = function create(properties) {
            return new GameState(properties);
        };

        /**
         * Encodes the specified GameState message. Does not implicitly {@link Texas.GameState.verify|verify} messages.
         * @function encode
         * @memberof Texas.GameState
         * @static
         * @param {Texas.IGameState} message GameState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameState.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
            if (message.dealPai != null && message.hasOwnProperty("dealPai"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dealPai);
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement"))
                $root.Texas.GameSettlement.encode(message.gameSettlement, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified GameState message, length delimited. Does not implicitly {@link Texas.GameState.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.GameState
         * @static
         * @param {Texas.IGameState} message GameState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameState.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameState message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.GameState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.GameState} GameState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameState.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameState();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.dealPai = reader.int32();
                    break;
                case 3:
                    message.gameSettlement = $root.Texas.GameSettlement.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("state"))
                throw $util.ProtocolError("missing required 'state'", { instance: message });
            return message;
        };

        /**
         * Decodes a GameState message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.GameState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.GameState} GameState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameState.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameState message.
         * @function verify
         * @memberof Texas.GameState
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameState.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.state))
                return "state: integer expected";
            if (message.dealPai != null && message.hasOwnProperty("dealPai"))
                if (!$util.isInteger(message.dealPai))
                    return "dealPai: integer expected";
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement")) {
                var error = $root.Texas.GameSettlement.verify(message.gameSettlement);
                if (error)
                    return "gameSettlement." + error;
            }
            return null;
        };

        /**
         * Creates a GameState message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.GameState
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.GameState} GameState
         */
        GameState.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.GameState)
                return object;
            var message = new $root.Texas.GameState();
            if (object.state != null)
                message.state = object.state | 0;
            if (object.dealPai != null)
                message.dealPai = object.dealPai | 0;
            if (object.gameSettlement != null) {
                if (typeof object.gameSettlement !== "object")
                    throw TypeError(".Texas.GameState.gameSettlement: object expected");
                message.gameSettlement = $root.Texas.GameSettlement.fromObject(object.gameSettlement);
            }
            return message;
        };

        /**
         * Creates a plain object from a GameState message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.GameState
         * @static
         * @param {Texas.GameState} message GameState
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameState.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.state = 0;
                object.dealPai = 0;
                object.gameSettlement = null;
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.dealPai != null && message.hasOwnProperty("dealPai"))
                object.dealPai = message.dealPai;
            if (message.gameSettlement != null && message.hasOwnProperty("gameSettlement"))
                object.gameSettlement = $root.Texas.GameSettlement.toObject(message.gameSettlement, options);
            return object;
        };

        /**
         * Converts this GameState to JSON.
         * @function toJSON
         * @memberof Texas.GameState
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameState.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameState;
    })();

    Texas.GameStart = (function() {

        /**
         * Properties of a GameStart.
         * @memberof Texas
         * @interface IGameStart
         * @property {number|null} [nextRoundStartTime] GameStart nextRoundStartTime
         */

        /**
         * Constructs a new GameStart.
         * @memberof Texas
         * @classdesc Represents a GameStart.
         * @implements IGameStart
         * @constructor
         * @param {Texas.IGameStart=} [properties] Properties to set
         */
        function GameStart(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameStart nextRoundStartTime.
         * @member {number} nextRoundStartTime
         * @memberof Texas.GameStart
         * @instance
         */
        GameStart.prototype.nextRoundStartTime = 0;

        /**
         * Creates a new GameStart instance using the specified properties.
         * @function create
         * @memberof Texas.GameStart
         * @static
         * @param {Texas.IGameStart=} [properties] Properties to set
         * @returns {Texas.GameStart} GameStart instance
         */
        GameStart.create = function create(properties) {
            return new GameStart(properties);
        };

        /**
         * Encodes the specified GameStart message. Does not implicitly {@link Texas.GameStart.verify|verify} messages.
         * @function encode
         * @memberof Texas.GameStart
         * @static
         * @param {Texas.IGameStart} message GameStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameStart.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.nextRoundStartTime);
            return writer;
        };

        /**
         * Encodes the specified GameStart message, length delimited. Does not implicitly {@link Texas.GameStart.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.GameStart
         * @static
         * @param {Texas.IGameStart} message GameStart message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameStart.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameStart message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.GameStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.GameStart} GameStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameStart.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameStart();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.nextRoundStartTime = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GameStart message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.GameStart
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.GameStart} GameStart
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameStart.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameStart message.
         * @function verify
         * @memberof Texas.GameStart
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameStart.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                if (!$util.isInteger(message.nextRoundStartTime))
                    return "nextRoundStartTime: integer expected";
            return null;
        };

        /**
         * Creates a GameStart message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.GameStart
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.GameStart} GameStart
         */
        GameStart.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.GameStart)
                return object;
            var message = new $root.Texas.GameStart();
            if (object.nextRoundStartTime != null)
                message.nextRoundStartTime = object.nextRoundStartTime | 0;
            return message;
        };

        /**
         * Creates a plain object from a GameStart message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.GameStart
         * @static
         * @param {Texas.GameStart} message GameStart
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameStart.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.nextRoundStartTime = 0;
            if (message.nextRoundStartTime != null && message.hasOwnProperty("nextRoundStartTime"))
                object.nextRoundStartTime = message.nextRoundStartTime;
            return object;
        };

        /**
         * Converts this GameStart to JSON.
         * @function toJSON
         * @memberof Texas.GameStart
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameStart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameStart;
    })();

    Texas.GameSettlement = (function() {

        /**
         * Properties of a GameSettlement.
         * @memberof Texas
         * @interface IGameSettlement
         * @property {Array.<Texas.GameSettlement.IPlayer>|null} [players] GameSettlement players
         * @property {number} totalBet GameSettlement totalBet
         * @property {boolean} endByFold GameSettlement endByFold
         */

        /**
         * Constructs a new GameSettlement.
         * @memberof Texas
         * @classdesc Represents a GameSettlement.
         * @implements IGameSettlement
         * @constructor
         * @param {Texas.IGameSettlement=} [properties] Properties to set
         */
        function GameSettlement(properties) {
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GameSettlement players.
         * @member {Array.<Texas.GameSettlement.IPlayer>} players
         * @memberof Texas.GameSettlement
         * @instance
         */
        GameSettlement.prototype.players = $util.emptyArray;

        /**
         * GameSettlement totalBet.
         * @member {number} totalBet
         * @memberof Texas.GameSettlement
         * @instance
         */
        GameSettlement.prototype.totalBet = 0;

        /**
         * GameSettlement endByFold.
         * @member {boolean} endByFold
         * @memberof Texas.GameSettlement
         * @instance
         */
        GameSettlement.prototype.endByFold = false;

        /**
         * Creates a new GameSettlement instance using the specified properties.
         * @function create
         * @memberof Texas.GameSettlement
         * @static
         * @param {Texas.IGameSettlement=} [properties] Properties to set
         * @returns {Texas.GameSettlement} GameSettlement instance
         */
        GameSettlement.create = function create(properties) {
            return new GameSettlement(properties);
        };

        /**
         * Encodes the specified GameSettlement message. Does not implicitly {@link Texas.GameSettlement.verify|verify} messages.
         * @function encode
         * @memberof Texas.GameSettlement
         * @static
         * @param {Texas.IGameSettlement} message GameSettlement message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettlement.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Texas.GameSettlement.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.totalBet);
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.endByFold);
            return writer;
        };

        /**
         * Encodes the specified GameSettlement message, length delimited. Does not implicitly {@link Texas.GameSettlement.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.GameSettlement
         * @static
         * @param {Texas.IGameSettlement} message GameSettlement message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GameSettlement.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GameSettlement message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.GameSettlement
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.GameSettlement} GameSettlement
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettlement.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameSettlement();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Texas.GameSettlement.Player.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalBet = reader.double();
                    break;
                case 5:
                    message.endByFold = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("totalBet"))
                throw $util.ProtocolError("missing required 'totalBet'", { instance: message });
            if (!message.hasOwnProperty("endByFold"))
                throw $util.ProtocolError("missing required 'endByFold'", { instance: message });
            return message;
        };

        /**
         * Decodes a GameSettlement message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.GameSettlement
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.GameSettlement} GameSettlement
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GameSettlement.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GameSettlement message.
         * @function verify
         * @memberof Texas.GameSettlement
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GameSettlement.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Texas.GameSettlement.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            if (typeof message.totalBet !== "number")
                return "totalBet: number expected";
            if (typeof message.endByFold !== "boolean")
                return "endByFold: boolean expected";
            return null;
        };

        /**
         * Creates a GameSettlement message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.GameSettlement
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.GameSettlement} GameSettlement
         */
        GameSettlement.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.GameSettlement)
                return object;
            var message = new $root.Texas.GameSettlement();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Texas.GameSettlement.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Texas.GameSettlement.players: object expected");
                    message.players[i] = $root.Texas.GameSettlement.Player.fromObject(object.players[i]);
                }
            }
            if (object.totalBet != null)
                message.totalBet = Number(object.totalBet);
            if (object.endByFold != null)
                message.endByFold = Boolean(object.endByFold);
            return message;
        };

        /**
         * Creates a plain object from a GameSettlement message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.GameSettlement
         * @static
         * @param {Texas.GameSettlement} message GameSettlement
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GameSettlement.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.players = [];
            if (options.defaults) {
                object.totalBet = 0;
                object.endByFold = false;
            }
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Texas.GameSettlement.Player.toObject(message.players[j], options);
            }
            if (message.totalBet != null && message.hasOwnProperty("totalBet"))
                object.totalBet = options.json && !isFinite(message.totalBet) ? String(message.totalBet) : message.totalBet;
            if (message.endByFold != null && message.hasOwnProperty("endByFold"))
                object.endByFold = message.endByFold;
            return object;
        };

        /**
         * Converts this GameSettlement to JSON.
         * @function toJSON
         * @memberof Texas.GameSettlement
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GameSettlement.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        GameSettlement.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof Texas.GameSettlement
             * @interface IPlayer
             * @property {number} playerId Player playerId
             * @property {number} playerPos Player playerPos
             * @property {Array.<number>|null} [cards] Player cards
             * @property {Texas.IMaxCardInfo|null} [maxCardInfo] Player maxCardInfo
             * @property {number} obtainChips Player obtainChips
             * @property {number} winLoseBet Player winLoseBet
             * @property {number|null} [feeGold] Player feeGold
             * @property {number|null} [gameBalance] Player gameBalance
             */

            /**
             * Constructs a new Player.
             * @memberof Texas.GameSettlement
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {Texas.GameSettlement.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                this.cards = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player playerId.
             * @member {number} playerId
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.playerId = 0;

            /**
             * Player playerPos.
             * @member {number} playerPos
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.playerPos = 0;

            /**
             * Player cards.
             * @member {Array.<number>} cards
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.cards = $util.emptyArray;

            /**
             * Player maxCardInfo.
             * @member {Texas.IMaxCardInfo|null|undefined} maxCardInfo
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.maxCardInfo = null;

            /**
             * Player obtainChips.
             * @member {number} obtainChips
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.obtainChips = 0;

            /**
             * Player winLoseBet.
             * @member {number} winLoseBet
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.winLoseBet = 0;

            /**
             * Player feeGold.
             * @member {number} feeGold
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.feeGold = 0;

            /**
             * Player gameBalance.
             * @member {number} gameBalance
             * @memberof Texas.GameSettlement.Player
             * @instance
             */
            Player.prototype.gameBalance = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Texas.GameSettlement.IPlayer=} [properties] Properties to set
             * @returns {Texas.GameSettlement.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link Texas.GameSettlement.Player.verify|verify} messages.
             * @function encode
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Texas.GameSettlement.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerPos);
                if (message.cards != null && message.cards.length)
                    for (var i = 0; i < message.cards.length; ++i)
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.cards[i]);
                if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                    $root.Texas.MaxCardInfo.encode(message.maxCardInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.obtainChips);
                writer.uint32(/* id 6, wireType 1 =*/49).double(message.winLoseBet);
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.feeGold);
                if (message.gameBalance != null && message.hasOwnProperty("gameBalance"))
                    writer.uint32(/* id 8, wireType 1 =*/65).double(message.gameBalance);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link Texas.GameSettlement.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Texas.GameSettlement.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Texas.GameSettlement.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.GameSettlement.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.playerPos = reader.int32();
                        break;
                    case 3:
                        if (!(message.cards && message.cards.length))
                            message.cards = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.cards.push(reader.int32());
                        } else
                            message.cards.push(reader.int32());
                        break;
                    case 4:
                        message.maxCardInfo = $root.Texas.MaxCardInfo.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.obtainChips = reader.double();
                        break;
                    case 6:
                        message.winLoseBet = reader.double();
                        break;
                    case 7:
                        message.feeGold = reader.double();
                        break;
                    case 8:
                        message.gameBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("playerId"))
                    throw $util.ProtocolError("missing required 'playerId'", { instance: message });
                if (!message.hasOwnProperty("playerPos"))
                    throw $util.ProtocolError("missing required 'playerPos'", { instance: message });
                if (!message.hasOwnProperty("obtainChips"))
                    throw $util.ProtocolError("missing required 'obtainChips'", { instance: message });
                if (!message.hasOwnProperty("winLoseBet"))
                    throw $util.ProtocolError("missing required 'winLoseBet'", { instance: message });
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Texas.GameSettlement.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
                if (!$util.isInteger(message.playerPos))
                    return "playerPos: integer expected";
                if (message.cards != null && message.hasOwnProperty("cards")) {
                    if (!Array.isArray(message.cards))
                        return "cards: array expected";
                    for (var i = 0; i < message.cards.length; ++i)
                        if (!$util.isInteger(message.cards[i]))
                            return "cards: integer[] expected";
                }
                if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo")) {
                    var error = $root.Texas.MaxCardInfo.verify(message.maxCardInfo);
                    if (error)
                        return "maxCardInfo." + error;
                }
                if (typeof message.obtainChips !== "number")
                    return "obtainChips: number expected";
                if (typeof message.winLoseBet !== "number")
                    return "winLoseBet: number expected";
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    if (typeof message.feeGold !== "number")
                        return "feeGold: number expected";
                if (message.gameBalance != null && message.hasOwnProperty("gameBalance"))
                    if (typeof message.gameBalance !== "number")
                        return "gameBalance: number expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Texas.GameSettlement.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.Texas.GameSettlement.Player)
                    return object;
                var message = new $root.Texas.GameSettlement.Player();
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.playerPos != null)
                    message.playerPos = object.playerPos | 0;
                if (object.cards) {
                    if (!Array.isArray(object.cards))
                        throw TypeError(".Texas.GameSettlement.Player.cards: array expected");
                    message.cards = [];
                    for (var i = 0; i < object.cards.length; ++i)
                        message.cards[i] = object.cards[i] | 0;
                }
                if (object.maxCardInfo != null) {
                    if (typeof object.maxCardInfo !== "object")
                        throw TypeError(".Texas.GameSettlement.Player.maxCardInfo: object expected");
                    message.maxCardInfo = $root.Texas.MaxCardInfo.fromObject(object.maxCardInfo);
                }
                if (object.obtainChips != null)
                    message.obtainChips = Number(object.obtainChips);
                if (object.winLoseBet != null)
                    message.winLoseBet = Number(object.winLoseBet);
                if (object.feeGold != null)
                    message.feeGold = Number(object.feeGold);
                if (object.gameBalance != null)
                    message.gameBalance = Number(object.gameBalance);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Texas.GameSettlement.Player
             * @static
             * @param {Texas.GameSettlement.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.cards = [];
                if (options.defaults) {
                    object.playerId = 0;
                    object.playerPos = 0;
                    object.maxCardInfo = null;
                    object.obtainChips = 0;
                    object.winLoseBet = 0;
                    object.feeGold = 0;
                    object.gameBalance = 0;
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                    object.playerPos = message.playerPos;
                if (message.cards && message.cards.length) {
                    object.cards = [];
                    for (var j = 0; j < message.cards.length; ++j)
                        object.cards[j] = message.cards[j];
                }
                if (message.maxCardInfo != null && message.hasOwnProperty("maxCardInfo"))
                    object.maxCardInfo = $root.Texas.MaxCardInfo.toObject(message.maxCardInfo, options);
                if (message.obtainChips != null && message.hasOwnProperty("obtainChips"))
                    object.obtainChips = options.json && !isFinite(message.obtainChips) ? String(message.obtainChips) : message.obtainChips;
                if (message.winLoseBet != null && message.hasOwnProperty("winLoseBet"))
                    object.winLoseBet = options.json && !isFinite(message.winLoseBet) ? String(message.winLoseBet) : message.winLoseBet;
                if (message.feeGold != null && message.hasOwnProperty("feeGold"))
                    object.feeGold = options.json && !isFinite(message.feeGold) ? String(message.feeGold) : message.feeGold;
                if (message.gameBalance != null && message.hasOwnProperty("gameBalance"))
                    object.gameBalance = options.json && !isFinite(message.gameBalance) ? String(message.gameBalance) : message.gameBalance;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof Texas.GameSettlement.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return GameSettlement;
    })();

    Texas.Recharge = (function() {

        /**
         * Properties of a Recharge.
         * @memberof Texas
         * @interface IRecharge
         * @property {number} coin Recharge coin
         * @property {boolean|null} [autoRecharge] Recharge autoRecharge
         */

        /**
         * Constructs a new Recharge.
         * @memberof Texas
         * @classdesc Represents a Recharge.
         * @implements IRecharge
         * @constructor
         * @param {Texas.IRecharge=} [properties] Properties to set
         */
        function Recharge(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Recharge coin.
         * @member {number} coin
         * @memberof Texas.Recharge
         * @instance
         */
        Recharge.prototype.coin = 0;

        /**
         * Recharge autoRecharge.
         * @member {boolean} autoRecharge
         * @memberof Texas.Recharge
         * @instance
         */
        Recharge.prototype.autoRecharge = false;

        /**
         * Creates a new Recharge instance using the specified properties.
         * @function create
         * @memberof Texas.Recharge
         * @static
         * @param {Texas.IRecharge=} [properties] Properties to set
         * @returns {Texas.Recharge} Recharge instance
         */
        Recharge.create = function create(properties) {
            return new Recharge(properties);
        };

        /**
         * Encodes the specified Recharge message. Does not implicitly {@link Texas.Recharge.verify|verify} messages.
         * @function encode
         * @memberof Texas.Recharge
         * @static
         * @param {Texas.IRecharge} message Recharge message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Recharge.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.coin);
            if (message.autoRecharge != null && message.hasOwnProperty("autoRecharge"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.autoRecharge);
            return writer;
        };

        /**
         * Encodes the specified Recharge message, length delimited. Does not implicitly {@link Texas.Recharge.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.Recharge
         * @static
         * @param {Texas.IRecharge} message Recharge message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Recharge.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Recharge message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.Recharge
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.Recharge} Recharge
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Recharge.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.Recharge();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.coin = reader.double();
                    break;
                case 2:
                    message.autoRecharge = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("coin"))
                throw $util.ProtocolError("missing required 'coin'", { instance: message });
            return message;
        };

        /**
         * Decodes a Recharge message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.Recharge
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.Recharge} Recharge
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Recharge.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Recharge message.
         * @function verify
         * @memberof Texas.Recharge
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Recharge.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.coin !== "number")
                return "coin: number expected";
            if (message.autoRecharge != null && message.hasOwnProperty("autoRecharge"))
                if (typeof message.autoRecharge !== "boolean")
                    return "autoRecharge: boolean expected";
            return null;
        };

        /**
         * Creates a Recharge message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.Recharge
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.Recharge} Recharge
         */
        Recharge.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.Recharge)
                return object;
            var message = new $root.Texas.Recharge();
            if (object.coin != null)
                message.coin = Number(object.coin);
            if (object.autoRecharge != null)
                message.autoRecharge = Boolean(object.autoRecharge);
            return message;
        };

        /**
         * Creates a plain object from a Recharge message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.Recharge
         * @static
         * @param {Texas.Recharge} message Recharge
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Recharge.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.coin = 0;
                object.autoRecharge = false;
            }
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = options.json && !isFinite(message.coin) ? String(message.coin) : message.coin;
            if (message.autoRecharge != null && message.hasOwnProperty("autoRecharge"))
                object.autoRecharge = message.autoRecharge;
            return object;
        };

        /**
         * Converts this Recharge to JSON.
         * @function toJSON
         * @memberof Texas.Recharge
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Recharge.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Recharge;
    })();

    Texas.SeatAction = (function() {

        /**
         * Properties of a SeatAction.
         * @memberof Texas
         * @interface ISeatAction
         * @property {number} type SeatAction type
         * @property {number|null} [seat] SeatAction seat
         * @property {Texas.IRecharge|null} [recharge] SeatAction recharge
         */

        /**
         * Constructs a new SeatAction.
         * @memberof Texas
         * @classdesc Represents a SeatAction.
         * @implements ISeatAction
         * @constructor
         * @param {Texas.ISeatAction=} [properties] Properties to set
         */
        function SeatAction(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatAction type.
         * @member {number} type
         * @memberof Texas.SeatAction
         * @instance
         */
        SeatAction.prototype.type = 0;

        /**
         * SeatAction seat.
         * @member {number} seat
         * @memberof Texas.SeatAction
         * @instance
         */
        SeatAction.prototype.seat = 0;

        /**
         * SeatAction recharge.
         * @member {Texas.IRecharge|null|undefined} recharge
         * @memberof Texas.SeatAction
         * @instance
         */
        SeatAction.prototype.recharge = null;

        /**
         * Creates a new SeatAction instance using the specified properties.
         * @function create
         * @memberof Texas.SeatAction
         * @static
         * @param {Texas.ISeatAction=} [properties] Properties to set
         * @returns {Texas.SeatAction} SeatAction instance
         */
        SeatAction.create = function create(properties) {
            return new SeatAction(properties);
        };

        /**
         * Encodes the specified SeatAction message. Does not implicitly {@link Texas.SeatAction.verify|verify} messages.
         * @function encode
         * @memberof Texas.SeatAction
         * @static
         * @param {Texas.ISeatAction} message SeatAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatAction.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
            if (message.seat != null && message.hasOwnProperty("seat"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seat);
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                $root.Texas.Recharge.encode(message.recharge, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SeatAction message, length delimited. Does not implicitly {@link Texas.SeatAction.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.SeatAction
         * @static
         * @param {Texas.ISeatAction} message SeatAction message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatAction.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatAction message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.SeatAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.SeatAction} SeatAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatAction.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SeatAction();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.seat = reader.int32();
                    break;
                case 3:
                    message.recharge = $root.Texas.Recharge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a SeatAction message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.SeatAction
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.SeatAction} SeatAction
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatAction.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatAction message.
         * @function verify
         * @memberof Texas.SeatAction
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatAction.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.seat != null && message.hasOwnProperty("seat"))
                if (!$util.isInteger(message.seat))
                    return "seat: integer expected";
            if (message.recharge != null && message.hasOwnProperty("recharge")) {
                var error = $root.Texas.Recharge.verify(message.recharge);
                if (error)
                    return "recharge." + error;
            }
            return null;
        };

        /**
         * Creates a SeatAction message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.SeatAction
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.SeatAction} SeatAction
         */
        SeatAction.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.SeatAction)
                return object;
            var message = new $root.Texas.SeatAction();
            if (object.type != null)
                message.type = object.type | 0;
            if (object.seat != null)
                message.seat = object.seat | 0;
            if (object.recharge != null) {
                if (typeof object.recharge !== "object")
                    throw TypeError(".Texas.SeatAction.recharge: object expected");
                message.recharge = $root.Texas.Recharge.fromObject(object.recharge);
            }
            return message;
        };

        /**
         * Creates a plain object from a SeatAction message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.SeatAction
         * @static
         * @param {Texas.SeatAction} message SeatAction
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatAction.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.type = 0;
                object.seat = 0;
                object.recharge = null;
            }
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.seat != null && message.hasOwnProperty("seat"))
                object.seat = message.seat;
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                object.recharge = $root.Texas.Recharge.toObject(message.recharge, options);
            return object;
        };

        /**
         * Converts this SeatAction to JSON.
         * @function toJSON
         * @memberof Texas.SeatAction
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatAction.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatAction;
    })();

    Texas.SeatActionReply = (function() {

        /**
         * Properties of a SeatActionReply.
         * @memberof Texas
         * @interface ISeatActionReply
         * @property {boolean} ok SeatActionReply ok
         * @property {number} type SeatActionReply type
         * @property {string|null} [desc] SeatActionReply desc
         * @property {number|null} [errorCode] SeatActionReply errorCode
         */

        /**
         * Constructs a new SeatActionReply.
         * @memberof Texas
         * @classdesc Represents a SeatActionReply.
         * @implements ISeatActionReply
         * @constructor
         * @param {Texas.ISeatActionReply=} [properties] Properties to set
         */
        function SeatActionReply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatActionReply ok.
         * @member {boolean} ok
         * @memberof Texas.SeatActionReply
         * @instance
         */
        SeatActionReply.prototype.ok = false;

        /**
         * SeatActionReply type.
         * @member {number} type
         * @memberof Texas.SeatActionReply
         * @instance
         */
        SeatActionReply.prototype.type = 0;

        /**
         * SeatActionReply desc.
         * @member {string} desc
         * @memberof Texas.SeatActionReply
         * @instance
         */
        SeatActionReply.prototype.desc = "";

        /**
         * SeatActionReply errorCode.
         * @member {number} errorCode
         * @memberof Texas.SeatActionReply
         * @instance
         */
        SeatActionReply.prototype.errorCode = 0;

        /**
         * Creates a new SeatActionReply instance using the specified properties.
         * @function create
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Texas.ISeatActionReply=} [properties] Properties to set
         * @returns {Texas.SeatActionReply} SeatActionReply instance
         */
        SeatActionReply.create = function create(properties) {
            return new SeatActionReply(properties);
        };

        /**
         * Encodes the specified SeatActionReply message. Does not implicitly {@link Texas.SeatActionReply.verify|verify} messages.
         * @function encode
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Texas.ISeatActionReply} message SeatActionReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatActionReply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.ok);
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
            if (message.desc != null && message.hasOwnProperty("desc"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.desc);
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.errorCode);
            return writer;
        };

        /**
         * Encodes the specified SeatActionReply message, length delimited. Does not implicitly {@link Texas.SeatActionReply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Texas.ISeatActionReply} message SeatActionReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatActionReply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatActionReply message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.SeatActionReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.SeatActionReply} SeatActionReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatActionReply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SeatActionReply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ok = reader.bool();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                case 3:
                    message.desc = reader.string();
                    break;
                case 4:
                    message.errorCode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("ok"))
                throw $util.ProtocolError("missing required 'ok'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a SeatActionReply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.SeatActionReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.SeatActionReply} SeatActionReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatActionReply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatActionReply message.
         * @function verify
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatActionReply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.ok !== "boolean")
                return "ok: boolean expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.desc != null && message.hasOwnProperty("desc"))
                if (!$util.isString(message.desc))
                    return "desc: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isInteger(message.errorCode))
                    return "errorCode: integer expected";
            return null;
        };

        /**
         * Creates a SeatActionReply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.SeatActionReply} SeatActionReply
         */
        SeatActionReply.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.SeatActionReply)
                return object;
            var message = new $root.Texas.SeatActionReply();
            if (object.ok != null)
                message.ok = Boolean(object.ok);
            if (object.type != null)
                message.type = object.type | 0;
            if (object.desc != null)
                message.desc = String(object.desc);
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            return message;
        };

        /**
         * Creates a plain object from a SeatActionReply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.SeatActionReply
         * @static
         * @param {Texas.SeatActionReply} message SeatActionReply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatActionReply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ok = false;
                object.type = 0;
                object.desc = "";
                object.errorCode = 0;
            }
            if (message.ok != null && message.hasOwnProperty("ok"))
                object.ok = message.ok;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.desc != null && message.hasOwnProperty("desc"))
                object.desc = message.desc;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            return object;
        };

        /**
         * Converts this SeatActionReply to JSON.
         * @function toJSON
         * @memberof Texas.SeatActionReply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatActionReply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatActionReply;
    })();

    Texas.SeatInfo = (function() {

        /**
         * Properties of a SeatInfo.
         * @memberof Texas
         * @interface ISeatInfo
         * @property {number} playerId SeatInfo playerId
         * @property {number|null} [seat] SeatInfo seat
         * @property {number} type SeatInfo type
         * @property {string|null} [playerInfo] SeatInfo playerInfo
         * @property {number|null} [num] SeatInfo num
         * @property {Texas.IRecharge|null} [recharge] SeatInfo recharge
         */

        /**
         * Constructs a new SeatInfo.
         * @memberof Texas
         * @classdesc Represents a SeatInfo.
         * @implements ISeatInfo
         * @constructor
         * @param {Texas.ISeatInfo=} [properties] Properties to set
         */
        function SeatInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatInfo playerId.
         * @member {number} playerId
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.playerId = 0;

        /**
         * SeatInfo seat.
         * @member {number} seat
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.seat = 0;

        /**
         * SeatInfo type.
         * @member {number} type
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.type = 0;

        /**
         * SeatInfo playerInfo.
         * @member {string} playerInfo
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.playerInfo = "";

        /**
         * SeatInfo num.
         * @member {number} num
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.num = 0;

        /**
         * SeatInfo recharge.
         * @member {Texas.IRecharge|null|undefined} recharge
         * @memberof Texas.SeatInfo
         * @instance
         */
        SeatInfo.prototype.recharge = null;

        /**
         * Creates a new SeatInfo instance using the specified properties.
         * @function create
         * @memberof Texas.SeatInfo
         * @static
         * @param {Texas.ISeatInfo=} [properties] Properties to set
         * @returns {Texas.SeatInfo} SeatInfo instance
         */
        SeatInfo.create = function create(properties) {
            return new SeatInfo(properties);
        };

        /**
         * Encodes the specified SeatInfo message. Does not implicitly {@link Texas.SeatInfo.verify|verify} messages.
         * @function encode
         * @memberof Texas.SeatInfo
         * @static
         * @param {Texas.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.seat != null && message.hasOwnProperty("seat"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.seat);
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.playerInfo);
            if (message.num != null && message.hasOwnProperty("num"))
                writer.uint32(/* id 5, wireType 1 =*/41).double(message.num);
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                $root.Texas.Recharge.encode(message.recharge, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SeatInfo message, length delimited. Does not implicitly {@link Texas.SeatInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.SeatInfo
         * @static
         * @param {Texas.ISeatInfo} message SeatInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SeatInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.seat = reader.int32();
                    break;
                case 3:
                    message.type = reader.int32();
                    break;
                case 4:
                    message.playerInfo = reader.string();
                    break;
                case 5:
                    message.num = reader.double();
                    break;
                case 6:
                    message.recharge = $root.Texas.Recharge.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            if (!message.hasOwnProperty("type"))
                throw $util.ProtocolError("missing required 'type'", { instance: message });
            return message;
        };

        /**
         * Decodes a SeatInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.SeatInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.SeatInfo} SeatInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatInfo message.
         * @function verify
         * @memberof Texas.SeatInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.seat != null && message.hasOwnProperty("seat"))
                if (!$util.isInteger(message.seat))
                    return "seat: integer expected";
            if (!$util.isInteger(message.type))
                return "type: integer expected";
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                if (!$util.isString(message.playerInfo))
                    return "playerInfo: string expected";
            if (message.num != null && message.hasOwnProperty("num"))
                if (typeof message.num !== "number")
                    return "num: number expected";
            if (message.recharge != null && message.hasOwnProperty("recharge")) {
                var error = $root.Texas.Recharge.verify(message.recharge);
                if (error)
                    return "recharge." + error;
            }
            return null;
        };

        /**
         * Creates a SeatInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.SeatInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.SeatInfo} SeatInfo
         */
        SeatInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.SeatInfo)
                return object;
            var message = new $root.Texas.SeatInfo();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.seat != null)
                message.seat = object.seat | 0;
            if (object.type != null)
                message.type = object.type | 0;
            if (object.playerInfo != null)
                message.playerInfo = String(object.playerInfo);
            if (object.num != null)
                message.num = Number(object.num);
            if (object.recharge != null) {
                if (typeof object.recharge !== "object")
                    throw TypeError(".Texas.SeatInfo.recharge: object expected");
                message.recharge = $root.Texas.Recharge.fromObject(object.recharge);
            }
            return message;
        };

        /**
         * Creates a plain object from a SeatInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.SeatInfo
         * @static
         * @param {Texas.SeatInfo} message SeatInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.seat = 0;
                object.type = 0;
                object.playerInfo = "";
                object.num = 0;
                object.recharge = null;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.seat != null && message.hasOwnProperty("seat"))
                object.seat = message.seat;
            if (message.type != null && message.hasOwnProperty("type"))
                object.type = message.type;
            if (message.playerInfo != null && message.hasOwnProperty("playerInfo"))
                object.playerInfo = message.playerInfo;
            if (message.num != null && message.hasOwnProperty("num"))
                object.num = options.json && !isFinite(message.num) ? String(message.num) : message.num;
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                object.recharge = $root.Texas.Recharge.toObject(message.recharge, options);
            return object;
        };

        /**
         * Converts this SeatInfo to JSON.
         * @function toJSON
         * @memberof Texas.SeatInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatInfo;
    })();

    Texas.SeatActionBroadcast = (function() {

        /**
         * Properties of a SeatActionBroadcast.
         * @memberof Texas
         * @interface ISeatActionBroadcast
         * @property {Array.<Texas.ISeatInfo>|null} [seats] SeatActionBroadcast seats
         * @property {number|null} [pot] SeatActionBroadcast pot
         * @property {boolean|null} [isSettle] SeatActionBroadcast isSettle
         */

        /**
         * Constructs a new SeatActionBroadcast.
         * @memberof Texas
         * @classdesc Represents a SeatActionBroadcast.
         * @implements ISeatActionBroadcast
         * @constructor
         * @param {Texas.ISeatActionBroadcast=} [properties] Properties to set
         */
        function SeatActionBroadcast(properties) {
            this.seats = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SeatActionBroadcast seats.
         * @member {Array.<Texas.ISeatInfo>} seats
         * @memberof Texas.SeatActionBroadcast
         * @instance
         */
        SeatActionBroadcast.prototype.seats = $util.emptyArray;

        /**
         * SeatActionBroadcast pot.
         * @member {number} pot
         * @memberof Texas.SeatActionBroadcast
         * @instance
         */
        SeatActionBroadcast.prototype.pot = 0;

        /**
         * SeatActionBroadcast isSettle.
         * @member {boolean} isSettle
         * @memberof Texas.SeatActionBroadcast
         * @instance
         */
        SeatActionBroadcast.prototype.isSettle = false;

        /**
         * Creates a new SeatActionBroadcast instance using the specified properties.
         * @function create
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Texas.ISeatActionBroadcast=} [properties] Properties to set
         * @returns {Texas.SeatActionBroadcast} SeatActionBroadcast instance
         */
        SeatActionBroadcast.create = function create(properties) {
            return new SeatActionBroadcast(properties);
        };

        /**
         * Encodes the specified SeatActionBroadcast message. Does not implicitly {@link Texas.SeatActionBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Texas.ISeatActionBroadcast} message SeatActionBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatActionBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.seats != null && message.seats.length)
                for (var i = 0; i < message.seats.length; ++i)
                    $root.Texas.SeatInfo.encode(message.seats[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.pot != null && message.hasOwnProperty("pot"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.pot);
            if (message.isSettle != null && message.hasOwnProperty("isSettle"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isSettle);
            return writer;
        };

        /**
         * Encodes the specified SeatActionBroadcast message, length delimited. Does not implicitly {@link Texas.SeatActionBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Texas.ISeatActionBroadcast} message SeatActionBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SeatActionBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SeatActionBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.SeatActionBroadcast} SeatActionBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatActionBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.SeatActionBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.seats && message.seats.length))
                        message.seats = [];
                    message.seats.push($root.Texas.SeatInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pot = reader.double();
                    break;
                case 3:
                    message.isSettle = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SeatActionBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.SeatActionBroadcast} SeatActionBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SeatActionBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SeatActionBroadcast message.
         * @function verify
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SeatActionBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.seats != null && message.hasOwnProperty("seats")) {
                if (!Array.isArray(message.seats))
                    return "seats: array expected";
                for (var i = 0; i < message.seats.length; ++i) {
                    var error = $root.Texas.SeatInfo.verify(message.seats[i]);
                    if (error)
                        return "seats." + error;
                }
            }
            if (message.pot != null && message.hasOwnProperty("pot"))
                if (typeof message.pot !== "number")
                    return "pot: number expected";
            if (message.isSettle != null && message.hasOwnProperty("isSettle"))
                if (typeof message.isSettle !== "boolean")
                    return "isSettle: boolean expected";
            return null;
        };

        /**
         * Creates a SeatActionBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.SeatActionBroadcast} SeatActionBroadcast
         */
        SeatActionBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.SeatActionBroadcast)
                return object;
            var message = new $root.Texas.SeatActionBroadcast();
            if (object.seats) {
                if (!Array.isArray(object.seats))
                    throw TypeError(".Texas.SeatActionBroadcast.seats: array expected");
                message.seats = [];
                for (var i = 0; i < object.seats.length; ++i) {
                    if (typeof object.seats[i] !== "object")
                        throw TypeError(".Texas.SeatActionBroadcast.seats: object expected");
                    message.seats[i] = $root.Texas.SeatInfo.fromObject(object.seats[i]);
                }
            }
            if (object.pot != null)
                message.pot = Number(object.pot);
            if (object.isSettle != null)
                message.isSettle = Boolean(object.isSettle);
            return message;
        };

        /**
         * Creates a plain object from a SeatActionBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.SeatActionBroadcast
         * @static
         * @param {Texas.SeatActionBroadcast} message SeatActionBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SeatActionBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.seats = [];
            if (options.defaults) {
                object.pot = 0;
                object.isSettle = false;
            }
            if (message.seats && message.seats.length) {
                object.seats = [];
                for (var j = 0; j < message.seats.length; ++j)
                    object.seats[j] = $root.Texas.SeatInfo.toObject(message.seats[j], options);
            }
            if (message.pot != null && message.hasOwnProperty("pot"))
                object.pot = options.json && !isFinite(message.pot) ? String(message.pot) : message.pot;
            if (message.isSettle != null && message.hasOwnProperty("isSettle"))
                object.isSettle = message.isSettle;
            return object;
        };

        /**
         * Converts this SeatActionBroadcast to JSON.
         * @function toJSON
         * @memberof Texas.SeatActionBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SeatActionBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SeatActionBroadcast;
    })();

    Texas.RechargeReply = (function() {

        /**
         * Properties of a RechargeReply.
         * @memberof Texas
         * @interface IRechargeReply
         * @property {boolean} ok RechargeReply ok
         * @property {string|null} [desc] RechargeReply desc
         * @property {number|null} [errorCode] RechargeReply errorCode
         * @property {Texas.IRecharge|null} [recharge] RechargeReply recharge
         * @property {boolean|null} [isPlaying] RechargeReply isPlaying
         */

        /**
         * Constructs a new RechargeReply.
         * @memberof Texas
         * @classdesc Represents a RechargeReply.
         * @implements IRechargeReply
         * @constructor
         * @param {Texas.IRechargeReply=} [properties] Properties to set
         */
        function RechargeReply(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RechargeReply ok.
         * @member {boolean} ok
         * @memberof Texas.RechargeReply
         * @instance
         */
        RechargeReply.prototype.ok = false;

        /**
         * RechargeReply desc.
         * @member {string} desc
         * @memberof Texas.RechargeReply
         * @instance
         */
        RechargeReply.prototype.desc = "";

        /**
         * RechargeReply errorCode.
         * @member {number} errorCode
         * @memberof Texas.RechargeReply
         * @instance
         */
        RechargeReply.prototype.errorCode = 0;

        /**
         * RechargeReply recharge.
         * @member {Texas.IRecharge|null|undefined} recharge
         * @memberof Texas.RechargeReply
         * @instance
         */
        RechargeReply.prototype.recharge = null;

        /**
         * RechargeReply isPlaying.
         * @member {boolean} isPlaying
         * @memberof Texas.RechargeReply
         * @instance
         */
        RechargeReply.prototype.isPlaying = false;

        /**
         * Creates a new RechargeReply instance using the specified properties.
         * @function create
         * @memberof Texas.RechargeReply
         * @static
         * @param {Texas.IRechargeReply=} [properties] Properties to set
         * @returns {Texas.RechargeReply} RechargeReply instance
         */
        RechargeReply.create = function create(properties) {
            return new RechargeReply(properties);
        };

        /**
         * Encodes the specified RechargeReply message. Does not implicitly {@link Texas.RechargeReply.verify|verify} messages.
         * @function encode
         * @memberof Texas.RechargeReply
         * @static
         * @param {Texas.IRechargeReply} message RechargeReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeReply.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.ok);
            if (message.desc != null && message.hasOwnProperty("desc"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.desc);
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.errorCode);
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                $root.Texas.Recharge.encode(message.recharge, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isPlaying);
            return writer;
        };

        /**
         * Encodes the specified RechargeReply message, length delimited. Does not implicitly {@link Texas.RechargeReply.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.RechargeReply
         * @static
         * @param {Texas.IRechargeReply} message RechargeReply message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeReply.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RechargeReply message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.RechargeReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.RechargeReply} RechargeReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeReply.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.RechargeReply();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ok = reader.bool();
                    break;
                case 2:
                    message.desc = reader.string();
                    break;
                case 3:
                    message.errorCode = reader.int32();
                    break;
                case 4:
                    message.recharge = $root.Texas.Recharge.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.isPlaying = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("ok"))
                throw $util.ProtocolError("missing required 'ok'", { instance: message });
            return message;
        };

        /**
         * Decodes a RechargeReply message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.RechargeReply
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.RechargeReply} RechargeReply
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeReply.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RechargeReply message.
         * @function verify
         * @memberof Texas.RechargeReply
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RechargeReply.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (typeof message.ok !== "boolean")
                return "ok: boolean expected";
            if (message.desc != null && message.hasOwnProperty("desc"))
                if (!$util.isString(message.desc))
                    return "desc: string expected";
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                if (!$util.isInteger(message.errorCode))
                    return "errorCode: integer expected";
            if (message.recharge != null && message.hasOwnProperty("recharge")) {
                var error = $root.Texas.Recharge.verify(message.recharge);
                if (error)
                    return "recharge." + error;
            }
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                if (typeof message.isPlaying !== "boolean")
                    return "isPlaying: boolean expected";
            return null;
        };

        /**
         * Creates a RechargeReply message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.RechargeReply
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.RechargeReply} RechargeReply
         */
        RechargeReply.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.RechargeReply)
                return object;
            var message = new $root.Texas.RechargeReply();
            if (object.ok != null)
                message.ok = Boolean(object.ok);
            if (object.desc != null)
                message.desc = String(object.desc);
            if (object.errorCode != null)
                message.errorCode = object.errorCode | 0;
            if (object.recharge != null) {
                if (typeof object.recharge !== "object")
                    throw TypeError(".Texas.RechargeReply.recharge: object expected");
                message.recharge = $root.Texas.Recharge.fromObject(object.recharge);
            }
            if (object.isPlaying != null)
                message.isPlaying = Boolean(object.isPlaying);
            return message;
        };

        /**
         * Creates a plain object from a RechargeReply message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.RechargeReply
         * @static
         * @param {Texas.RechargeReply} message RechargeReply
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RechargeReply.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.ok = false;
                object.desc = "";
                object.errorCode = 0;
                object.recharge = null;
                object.isPlaying = false;
            }
            if (message.ok != null && message.hasOwnProperty("ok"))
                object.ok = message.ok;
            if (message.desc != null && message.hasOwnProperty("desc"))
                object.desc = message.desc;
            if (message.errorCode != null && message.hasOwnProperty("errorCode"))
                object.errorCode = message.errorCode;
            if (message.recharge != null && message.hasOwnProperty("recharge"))
                object.recharge = $root.Texas.Recharge.toObject(message.recharge, options);
            if (message.isPlaying != null && message.hasOwnProperty("isPlaying"))
                object.isPlaying = message.isPlaying;
            return object;
        };

        /**
         * Converts this RechargeReply to JSON.
         * @function toJSON
         * @memberof Texas.RechargeReply
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RechargeReply.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RechargeReply;
    })();

    Texas.Error = (function() {

        /**
         * Properties of an Error.
         * @memberof Texas
         * @interface IError
         * @property {number} error Error error
         * @property {string|null} [desc] Error desc
         */

        /**
         * Constructs a new Error.
         * @memberof Texas
         * @classdesc Represents an Error.
         * @implements IError
         * @constructor
         * @param {Texas.IError=} [properties] Properties to set
         */
        function Error(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Error error.
         * @member {number} error
         * @memberof Texas.Error
         * @instance
         */
        Error.prototype.error = 0;

        /**
         * Error desc.
         * @member {string} desc
         * @memberof Texas.Error
         * @instance
         */
        Error.prototype.desc = "";

        /**
         * Creates a new Error instance using the specified properties.
         * @function create
         * @memberof Texas.Error
         * @static
         * @param {Texas.IError=} [properties] Properties to set
         * @returns {Texas.Error} Error instance
         */
        Error.create = function create(properties) {
            return new Error(properties);
        };

        /**
         * Encodes the specified Error message. Does not implicitly {@link Texas.Error.verify|verify} messages.
         * @function encode
         * @memberof Texas.Error
         * @static
         * @param {Texas.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.error);
            if (message.desc != null && message.hasOwnProperty("desc"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.desc);
            return writer;
        };

        /**
         * Encodes the specified Error message, length delimited. Does not implicitly {@link Texas.Error.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.Error
         * @static
         * @param {Texas.IError} message Error message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Error.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Error message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.Error();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.error = reader.int32();
                    break;
                case 2:
                    message.desc = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("error"))
                throw $util.ProtocolError("missing required 'error'", { instance: message });
            return message;
        };

        /**
         * Decodes an Error message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.Error
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.Error} Error
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Error.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Error message.
         * @function verify
         * @memberof Texas.Error
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Error.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.error))
                return "error: integer expected";
            if (message.desc != null && message.hasOwnProperty("desc"))
                if (!$util.isString(message.desc))
                    return "desc: string expected";
            return null;
        };

        /**
         * Creates an Error message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.Error
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.Error} Error
         */
        Error.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.Error)
                return object;
            var message = new $root.Texas.Error();
            if (object.error != null)
                message.error = object.error | 0;
            if (object.desc != null)
                message.desc = String(object.desc);
            return message;
        };

        /**
         * Creates a plain object from an Error message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.Error
         * @static
         * @param {Texas.Error} message Error
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Error.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.error = 0;
                object.desc = "";
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.desc != null && message.hasOwnProperty("desc"))
                object.desc = message.desc;
            return object;
        };

        /**
         * Converts this Error to JSON.
         * @function toJSON
         * @memberof Texas.Error
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Error.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Error;
    })();

    Texas.MaxCardInfo = (function() {

        /**
         * Properties of a MaxCardInfo.
         * @memberof Texas
         * @interface IMaxCardInfo
         * @property {Array.<number>|null} [highLightCards] MaxCardInfo highLightCards
         * @property {Array.<number>|null} [maxCards] MaxCardInfo maxCards
         * @property {number|null} [maxCardsType] MaxCardInfo maxCardsType
         */

        /**
         * Constructs a new MaxCardInfo.
         * @memberof Texas
         * @classdesc Represents a MaxCardInfo.
         * @implements IMaxCardInfo
         * @constructor
         * @param {Texas.IMaxCardInfo=} [properties] Properties to set
         */
        function MaxCardInfo(properties) {
            this.highLightCards = [];
            this.maxCards = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MaxCardInfo highLightCards.
         * @member {Array.<number>} highLightCards
         * @memberof Texas.MaxCardInfo
         * @instance
         */
        MaxCardInfo.prototype.highLightCards = $util.emptyArray;

        /**
         * MaxCardInfo maxCards.
         * @member {Array.<number>} maxCards
         * @memberof Texas.MaxCardInfo
         * @instance
         */
        MaxCardInfo.prototype.maxCards = $util.emptyArray;

        /**
         * MaxCardInfo maxCardsType.
         * @member {number} maxCardsType
         * @memberof Texas.MaxCardInfo
         * @instance
         */
        MaxCardInfo.prototype.maxCardsType = 0;

        /**
         * Creates a new MaxCardInfo instance using the specified properties.
         * @function create
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Texas.IMaxCardInfo=} [properties] Properties to set
         * @returns {Texas.MaxCardInfo} MaxCardInfo instance
         */
        MaxCardInfo.create = function create(properties) {
            return new MaxCardInfo(properties);
        };

        /**
         * Encodes the specified MaxCardInfo message. Does not implicitly {@link Texas.MaxCardInfo.verify|verify} messages.
         * @function encode
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Texas.IMaxCardInfo} message MaxCardInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MaxCardInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.highLightCards != null && message.highLightCards.length)
                for (var i = 0; i < message.highLightCards.length; ++i)
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.highLightCards[i]);
            if (message.maxCards != null && message.maxCards.length)
                for (var i = 0; i < message.maxCards.length; ++i)
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxCards[i]);
            if (message.maxCardsType != null && message.hasOwnProperty("maxCardsType"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxCardsType);
            return writer;
        };

        /**
         * Encodes the specified MaxCardInfo message, length delimited. Does not implicitly {@link Texas.MaxCardInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Texas.IMaxCardInfo} message MaxCardInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MaxCardInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MaxCardInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.MaxCardInfo} MaxCardInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MaxCardInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.MaxCardInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.highLightCards && message.highLightCards.length))
                        message.highLightCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.highLightCards.push(reader.int32());
                    } else
                        message.highLightCards.push(reader.int32());
                    break;
                case 2:
                    if (!(message.maxCards && message.maxCards.length))
                        message.maxCards = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.maxCards.push(reader.int32());
                    } else
                        message.maxCards.push(reader.int32());
                    break;
                case 3:
                    message.maxCardsType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MaxCardInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.MaxCardInfo} MaxCardInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MaxCardInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MaxCardInfo message.
         * @function verify
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MaxCardInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.highLightCards != null && message.hasOwnProperty("highLightCards")) {
                if (!Array.isArray(message.highLightCards))
                    return "highLightCards: array expected";
                for (var i = 0; i < message.highLightCards.length; ++i)
                    if (!$util.isInteger(message.highLightCards[i]))
                        return "highLightCards: integer[] expected";
            }
            if (message.maxCards != null && message.hasOwnProperty("maxCards")) {
                if (!Array.isArray(message.maxCards))
                    return "maxCards: array expected";
                for (var i = 0; i < message.maxCards.length; ++i)
                    if (!$util.isInteger(message.maxCards[i]))
                        return "maxCards: integer[] expected";
            }
            if (message.maxCardsType != null && message.hasOwnProperty("maxCardsType"))
                if (!$util.isInteger(message.maxCardsType))
                    return "maxCardsType: integer expected";
            return null;
        };

        /**
         * Creates a MaxCardInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.MaxCardInfo} MaxCardInfo
         */
        MaxCardInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.MaxCardInfo)
                return object;
            var message = new $root.Texas.MaxCardInfo();
            if (object.highLightCards) {
                if (!Array.isArray(object.highLightCards))
                    throw TypeError(".Texas.MaxCardInfo.highLightCards: array expected");
                message.highLightCards = [];
                for (var i = 0; i < object.highLightCards.length; ++i)
                    message.highLightCards[i] = object.highLightCards[i] | 0;
            }
            if (object.maxCards) {
                if (!Array.isArray(object.maxCards))
                    throw TypeError(".Texas.MaxCardInfo.maxCards: array expected");
                message.maxCards = [];
                for (var i = 0; i < object.maxCards.length; ++i)
                    message.maxCards[i] = object.maxCards[i] | 0;
            }
            if (object.maxCardsType != null)
                message.maxCardsType = object.maxCardsType | 0;
            return message;
        };

        /**
         * Creates a plain object from a MaxCardInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.MaxCardInfo
         * @static
         * @param {Texas.MaxCardInfo} message MaxCardInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MaxCardInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.highLightCards = [];
                object.maxCards = [];
            }
            if (options.defaults)
                object.maxCardsType = 0;
            if (message.highLightCards && message.highLightCards.length) {
                object.highLightCards = [];
                for (var j = 0; j < message.highLightCards.length; ++j)
                    object.highLightCards[j] = message.highLightCards[j];
            }
            if (message.maxCards && message.maxCards.length) {
                object.maxCards = [];
                for (var j = 0; j < message.maxCards.length; ++j)
                    object.maxCards[j] = message.maxCards[j];
            }
            if (message.maxCardsType != null && message.hasOwnProperty("maxCardsType"))
                object.maxCardsType = message.maxCardsType;
            return object;
        };

        /**
         * Converts this MaxCardInfo to JSON.
         * @function toJSON
         * @memberof Texas.MaxCardInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MaxCardInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MaxCardInfo;
    })();

    Texas.CoinStatus = (function() {

        /**
         * Properties of a CoinStatus.
         * @memberof Texas
         * @interface ICoinStatus
         * @property {number} status CoinStatus status
         */

        /**
         * Constructs a new CoinStatus.
         * @memberof Texas
         * @classdesc Represents a CoinStatus.
         * @implements ICoinStatus
         * @constructor
         * @param {Texas.ICoinStatus=} [properties] Properties to set
         */
        function CoinStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CoinStatus status.
         * @member {number} status
         * @memberof Texas.CoinStatus
         * @instance
         */
        CoinStatus.prototype.status = 0;

        /**
         * Creates a new CoinStatus instance using the specified properties.
         * @function create
         * @memberof Texas.CoinStatus
         * @static
         * @param {Texas.ICoinStatus=} [properties] Properties to set
         * @returns {Texas.CoinStatus} CoinStatus instance
         */
        CoinStatus.create = function create(properties) {
            return new CoinStatus(properties);
        };

        /**
         * Encodes the specified CoinStatus message. Does not implicitly {@link Texas.CoinStatus.verify|verify} messages.
         * @function encode
         * @memberof Texas.CoinStatus
         * @static
         * @param {Texas.ICoinStatus} message CoinStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoinStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified CoinStatus message, length delimited. Does not implicitly {@link Texas.CoinStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.CoinStatus
         * @static
         * @param {Texas.ICoinStatus} message CoinStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CoinStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CoinStatus message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.CoinStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.CoinStatus} CoinStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoinStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.CoinStatus();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("status"))
                throw $util.ProtocolError("missing required 'status'", { instance: message });
            return message;
        };

        /**
         * Decodes a CoinStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.CoinStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.CoinStatus} CoinStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CoinStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CoinStatus message.
         * @function verify
         * @memberof Texas.CoinStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CoinStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.status))
                return "status: integer expected";
            return null;
        };

        /**
         * Creates a CoinStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.CoinStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.CoinStatus} CoinStatus
         */
        CoinStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.CoinStatus)
                return object;
            var message = new $root.Texas.CoinStatus();
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from a CoinStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.CoinStatus
         * @static
         * @param {Texas.CoinStatus} message CoinStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CoinStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.status = 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this CoinStatus to JSON.
         * @function toJSON
         * @memberof Texas.CoinStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CoinStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CoinStatus;
    })();

    Texas.UserMsg = (function() {

        /**
         * Properties of a UserMsg.
         * @memberof Texas
         * @interface IUserMsg
         * @property {number} playerPos UserMsg playerPos
         * @property {number|null} [num] UserMsg num
         * @property {number|null} [balance] UserMsg balance
         */

        /**
         * Constructs a new UserMsg.
         * @memberof Texas
         * @classdesc Represents a UserMsg.
         * @implements IUserMsg
         * @constructor
         * @param {Texas.IUserMsg=} [properties] Properties to set
         */
        function UserMsg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserMsg playerPos.
         * @member {number} playerPos
         * @memberof Texas.UserMsg
         * @instance
         */
        UserMsg.prototype.playerPos = 0;

        /**
         * UserMsg num.
         * @member {number} num
         * @memberof Texas.UserMsg
         * @instance
         */
        UserMsg.prototype.num = 0;

        /**
         * UserMsg balance.
         * @member {number} balance
         * @memberof Texas.UserMsg
         * @instance
         */
        UserMsg.prototype.balance = 0;

        /**
         * Creates a new UserMsg instance using the specified properties.
         * @function create
         * @memberof Texas.UserMsg
         * @static
         * @param {Texas.IUserMsg=} [properties] Properties to set
         * @returns {Texas.UserMsg} UserMsg instance
         */
        UserMsg.create = function create(properties) {
            return new UserMsg(properties);
        };

        /**
         * Encodes the specified UserMsg message. Does not implicitly {@link Texas.UserMsg.verify|verify} messages.
         * @function encode
         * @memberof Texas.UserMsg
         * @static
         * @param {Texas.IUserMsg} message UserMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerPos);
            if (message.num != null && message.hasOwnProperty("num"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.num);
            if (message.balance != null && message.hasOwnProperty("balance"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.balance);
            return writer;
        };

        /**
         * Encodes the specified UserMsg message, length delimited. Does not implicitly {@link Texas.UserMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Texas.UserMsg
         * @static
         * @param {Texas.IUserMsg} message UserMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserMsg message from the specified reader or buffer.
         * @function decode
         * @memberof Texas.UserMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Texas.UserMsg} UserMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Texas.UserMsg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerPos = reader.int32();
                    break;
                case 2:
                    message.num = reader.double();
                    break;
                case 3:
                    message.balance = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerPos"))
                throw $util.ProtocolError("missing required 'playerPos'", { instance: message });
            return message;
        };

        /**
         * Decodes a UserMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Texas.UserMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Texas.UserMsg} UserMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserMsg message.
         * @function verify
         * @memberof Texas.UserMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerPos))
                return "playerPos: integer expected";
            if (message.num != null && message.hasOwnProperty("num"))
                if (typeof message.num !== "number")
                    return "num: number expected";
            if (message.balance != null && message.hasOwnProperty("balance"))
                if (typeof message.balance !== "number")
                    return "balance: number expected";
            return null;
        };

        /**
         * Creates a UserMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Texas.UserMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Texas.UserMsg} UserMsg
         */
        UserMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.Texas.UserMsg)
                return object;
            var message = new $root.Texas.UserMsg();
            if (object.playerPos != null)
                message.playerPos = object.playerPos | 0;
            if (object.num != null)
                message.num = Number(object.num);
            if (object.balance != null)
                message.balance = Number(object.balance);
            return message;
        };

        /**
         * Creates a plain object from a UserMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Texas.UserMsg
         * @static
         * @param {Texas.UserMsg} message UserMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerPos = 0;
                object.num = 0;
                object.balance = 0;
            }
            if (message.playerPos != null && message.hasOwnProperty("playerPos"))
                object.playerPos = message.playerPos;
            if (message.num != null && message.hasOwnProperty("num"))
                object.num = options.json && !isFinite(message.num) ? String(message.num) : message.num;
            if (message.balance != null && message.hasOwnProperty("balance"))
                object.balance = options.json && !isFinite(message.balance) ? String(message.balance) : message.balance;
            return object;
        };

        /**
         * Converts this UserMsg to JSON.
         * @function toJSON
         * @memberof Texas.UserMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserMsg;
    })();

    return Texas;
})();

module.exports = $root;
